import React, { useEffect, useState, useRef, Component } from 'react';
import { ArrowLeftIcon, FileTextIcon, UserIcon, BuildingIcon, CalendarIcon, ClockIcon, DollarSignIcon, CheckCircleIcon, XCircleIcon, SendIcon, DownloadIcon, PrinterIcon, PencilIcon, TrashIcon, RefreshCwIcon, ExternalLinkIcon, TagIcon, MailIcon, PhoneIcon, MapPinIcon, InfoIcon, CheckIcon, AlertCircleIcon, PackageIcon, TruckIcon, BarChart2Icon, StarIcon, ClipboardIcon, MoreHorizontalIcon, BookmarkIcon, ShareIcon, EyeIcon, ChevronRightIcon, MessageSquareIcon, LinkIcon, MoreVerticalIcon, ChevronDownIcon, ArrowUpRightIcon, ArchiveIcon, CopyIcon, HeartIcon, FolderIcon, FileIcon, PieChartIcon, BellIcon, BadgeCheckIcon, ShoppingCartIcon, HistoryIcon, StickyNoteIcon, ThumbsUpIcon, ThumbsDownIcon, HelpCircleIcon, CreditCardIcon, GlobeIcon, ZapIcon, Activity, Edit2Icon, PlusIcon, MoveRightIcon, ChevronLeftIcon, UsersIcon, PercentIcon, ShieldIcon, LockIcon, Layers, BarChart, PenToolIcon, XIcon, FilterIcon, TrendingUpIcon, TrendingDownIcon, DollarSign, Target, Zap, CheckSquare, Clock, Clipboard, Hash, Paperclip, Briefcase, Users, LayoutDashboard, CrownIcon, LayoutIcon } from 'lucide-react';
export function ViewQuotePage({
  quoteData,
  onBack,
  onEdit
}) {
  const [activeSection, setActiveSection] = useState('overview');
  const [isFavorite, setIsFavorite] = useState(false);
  const [currentItemDetails, setCurrentItemDetails] = useState(null);
  const [showSidebar, setShowSidebar] = useState(true);
  const [showNotes, setShowNotes] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [showItemDrawer, setShowItemDrawer] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showActionMenu, setShowActionMenu] = useState(false);
  const [showShareMenu, setShowShareMenu] = useState(false);
  const [newNote, setNewNote] = useState('');
  const [privateNote, setPrivateNote] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState('standard');
  const [showTemplateSelector, setShowTemplateSelector] = useState(false);
  const actionMenuRef = useRef(null);
  const shareMenuRef = useRef(null);
  const printableQuoteRef = useRef(null);
  const templateSelectorRef = useRef(null);
  // Close menus when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (actionMenuRef.current && !actionMenuRef.current.contains(event.target)) {
        setShowActionMenu(false);
      }
      if (shareMenuRef.current && !shareMenuRef.current.contains(event.target)) {
        setShowShareMenu(false);
      }
      if (templateSelectorRef.current && !templateSelectorRef.current.contains(event.target)) {
        setShowTemplateSelector(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  // Toggle favorite status
  const toggleFavorite = () => {
    setIsFavorite(!isFavorite);
  };
  // Handle showing item details
  const handleViewItem = item => {
    setSelectedItem(item);
    setShowItemDrawer(true);
  };
  // Handle adding a new note
  const handleAddNote = () => {
    if (newNote.trim() === '') return;
    // Here you would typically add the note to your state or send to backend
    console.log('Adding note:', newNote, 'Private:', privateNote);
    // Reset form
    setNewNote('');
    setPrivateNote(false);
  };
  // Handle printing the quote
  const handlePrintQuote = () => {
    const printContent = printableQuoteRef.current;
    if (!printContent) return;
    const originalContents = document.body.innerHTML;
    const printContents = printContent.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    // Re-attach event listeners
    window.location.reload();
  };
  // Toggle template selector
  const toggleTemplateSelector = () => {
    setShowTemplateSelector(!showTemplateSelector);
  };
  // Select template
  const handleSelectTemplate = template => {
    setSelectedTemplate(template);
    setShowTemplateSelector(false);
  };
  // Ejemplo de datos para la demostración
  const quote = {
    id: quoteData?.id || 'QT-5875',
    status: 'pending',
    title: '8" Valley Pivot System with Corner Arm',
    description: 'Complete irrigation system with corner arm extension for rectangular fields',
    customer: 'Unknown Customer',
    customerEmail: 'contact@example.com',
    customerPhone: '+1 (555) 123-4567',
    company: 'Direct Customer',
    companyAddress: '123 Irrigation Blvd, Farmington, CA 95689, United States',
    date: 'Unknown date',
    expiresIn: '2023-12-31',
    amount: 27820.0,
    currency: '$',
    discount: 10,
    tax: 7,
    taxAmount: 1947.4,
    total: 29767.4,
    quotedBy: 'Unknown',
    salesManager: 'Unknown',
    region: 'North America',
    country: 'USA',
    paymentTerms: 'Net 30',
    deliveryTerms: 'FOB Shipping Point',
    validityPeriod: '30 days',
    tags: ['Pivot', 'Corner'],
    items: [{
      id: 1,
      name: '8" Valley Pivot',
      description: 'Standard 8-inch Valley Pivot system with GPS',
      quantity: 1,
      unitPrice: 18500.0,
      discount: 0,
      total: 18500.0
    }, {
      id: 2,
      name: 'Corner Arm Extension',
      description: 'Corner arm extension for increased coverage',
      quantity: 1,
      unitPrice: 5200.0,
      discount: 0,
      total: 5200.0
    }, {
      id: 3,
      name: 'Smart Control Panel',
      description: 'Advanced control panel with remote access',
      quantity: 1,
      unitPrice: 1800.0,
      discount: 10,
      total: 1620.0
    }, {
      id: 4,
      name: 'Installation Service',
      description: 'Professional installation and setup',
      quantity: 1,
      unitPrice: 2500.0,
      discount: 0,
      total: 2500.0
    }],
    notes: [{
      id: 1,
      text: 'Customer requires installation before the growing season starts in April. System should be configured for corn and soybean rotation.',
      author: 'John Smith',
      date: '2 days ago',
      isPrivate: false
    }, {
      id: 2,
      text: 'Follow up with customer about payment schedule options.',
      author: 'Sarah Johnson',
      date: '1 day ago',
      isPrivate: true
    }],
    terms: 'This quote is valid for 30 days from the date of issue. Installation schedule to be determined upon acceptance.',
    attachments: [{
      name: 'System_Specifications.pdf',
      size: '2.4 MB',
      type: 'pdf'
    }, {
      name: 'Field_Layout.pdf',
      size: '1.8 MB',
      type: 'pdf'
    }, {
      name: 'Terms_and_Conditions.pdf',
      size: '0.5 MB',
      type: 'pdf'
    }, {
      name: 'Installation_Guide.pdf',
      size: '3.2 MB',
      type: 'pdf'
    }],
    history: [{
      date: '3 days ago',
      action: 'Quote created',
      user: 'Daniel Alejandro',
      details: 'Initial quote created with 4 items'
    }, {
      date: '2 days ago',
      action: 'Quote sent to customer',
      user: 'Daniel Alejandro',
      details: 'Quote #QT-5875 sent via email to contact@example.com'
    }, {
      date: '1 day ago',
      action: 'Customer viewed quote',
      user: 'System',
      details: 'Quote was viewed by customer via the shared link'
    }, {
      date: '5 hours ago',
      action: 'Quote updated',
      user: 'Daniel Alejandro',
      details: 'Added 10% discount to Smart Control Panel'
    }],
    score: 92,
    approvalStatus: {
      level1: {
        name: 'Sales Manager',
        status: 'approved',
        date: '3 days ago',
        by: 'John Smith'
      },
      level2: {
        name: 'Finance Department',
        status: 'pending',
        date: null,
        by: null
      },
      level3: {
        name: 'Executive Approval',
        status: 'not_required',
        date: null,
        by: null
      }
    },
    competitors: [{
      name: 'IrriTech Solutions',
      price: 32150.0,
      strengths: 'Longer warranty, 24/7 support',
      weaknesses: 'More expensive, longer delivery time'
    }, {
      name: 'FarmSystems Inc.',
      price: 26500.0,
      strengths: 'Lower price point, faster installation',
      weaknesses: 'Less durable components, limited support'
    }]
  };
  // Format currency
  const formatCurrency = amount => {
    return `$${amount.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };
  // Get status config
  const getStatusConfig = status => {
    switch (status) {
      case 'pending':
        return {
          icon: <Clock size={14} className="text-amber-500" data-id="element-5329" />,
          label: 'Pending Approval',
          color: 'bg-amber-100 text-amber-700 border-amber-200'
        };
      case 'approved':
        return {
          icon: <CheckSquare size={14} className="text-green-500" data-id="element-5330" />,
          label: 'Approved',
          color: 'bg-green-100 text-green-700 border-green-200'
        };
      case 'expired':
        return {
          icon: <XCircleIcon size={14} className="text-red-500" data-id="element-5331" />,
          label: 'Expired',
          color: 'bg-red-100 text-red-700 border-red-200'
        };
      case 'draft':
        return {
          icon: <Edit2Icon size={14} className="text-blue-500" data-id="element-5332" />,
          label: 'Draft',
          color: 'bg-blue-100 text-blue-700 border-blue-200'
        };
      default:
        return {
          icon: <InfoIcon size={14} className="text-gray-500" data-id="element-5333" />,
          label: 'Unknown',
          color: 'bg-gray-100 text-gray-700 border-gray-200'
        };
    }
  };
  // Get file icon based on type
  const getFileIcon = fileType => {
    switch (fileType) {
      case 'pdf':
        return <FileTextIcon size={16} className="text-red-500" data-id="element-5334" />;
      case 'doc':
      case 'docx':
        return <FileTextIcon size={16} className="text-blue-500" data-id="element-5335" />;
      case 'xls':
      case 'xlsx':
        return <FileTextIcon size={16} className="text-green-500" data-id="element-5336" />;
      case 'jpg':
      case 'png':
        return <FileIcon size={16} className="text-purple-500" data-id="element-5337" />;
      default:
        return <FileIcon size={16} className="text-gray-500" data-id="element-5338" />;
    }
  };
  // Calculate days remaining until expiry
  const getDaysRemaining = () => {
    if (!quote.expiresIn) return 0;
    const today = new Date();
    const expiryDate = new Date(quote.expiresIn);
    const timeDiff = expiryDate.getTime() - today.getTime();
    return Math.ceil(timeDiff / (1000 * 3600 * 24));
  };
  const daysRemaining = getDaysRemaining();
  // Get expiry status and color
  const getExpiryStatus = () => {
    if (daysRemaining <= 0) {
      return {
        label: 'Expired',
        color: 'text-red-500',
        icon: <XCircleIcon size={14} className="text-red-500" data-id="element-5339" />
      };
    } else if (daysRemaining <= 7) {
      return {
        label: `Expires in ${daysRemaining} days`,
        color: 'text-amber-500',
        icon: <AlertCircleIcon size={14} className="text-amber-500" data-id="element-5340" />
      };
    } else {
      return {
        label: `Expires in ${daysRemaining} days`,
        color: 'text-green-500',
        icon: <CheckCircleIcon size={14} className="text-green-500" data-id="element-5341" />
      };
    }
  };
  const expiryStatus = getExpiryStatus();
  // Calculate score color
  const getScoreColor = score => {
    if (score >= 80) return 'text-green-500';
    if (score >= 60) return 'text-blue-500';
    if (score >= 40) return 'text-amber-500';
    return 'text-red-500';
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-5342">
      {/* Left sidebar - Navigation */}
      {showSidebar && <div className="w-64 bg-white border-r border-gray-200 flex flex-col h-full" data-id="element-5343">
          <div className="p-4 border-b border-gray-200 flex items-center justify-between" data-id="element-5344">
            <button onClick={onBack} className="text-gray-500 hover:text-gray-700 flex items-center text-sm font-medium" data-id="element-5345">
              <ArrowLeftIcon size={16} className="mr-2" data-id="element-5346" />
              Back to Quotes
            </button>
            <button onClick={() => setShowSidebar(false)} className="text-gray-400 hover:text-gray-600" data-id="element-5347">
              <ChevronLeftIcon size={18} data-id="element-5348" />
            </button>
          </div>
          <div className="p-4" data-id="element-5349">
            <div className="flex items-center justify-between mb-4" data-id="element-5350">
              <div className="flex items-center" data-id="element-5351">
                <div className="bg-blue-100 p-2 rounded-md" data-id="element-5352">
                  <FileTextIcon size={16} className="text-blue-600" data-id="element-5353" />
                </div>
                <div className="ml-3" data-id="element-5354">
                  <h2 className="text-sm font-medium text-gray-900" data-id="element-5355">
                    Quote #{quote.id}
                  </h2>
                  <p className="text-xs text-gray-500" data-id="element-5356">Standard Quote</p>
                </div>
              </div>
              <button onClick={toggleFavorite} className={`${isFavorite ? 'text-amber-500' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-5357">
                <BookmarkIcon size={16} className={isFavorite ? 'fill-amber-500' : ''} data-id="element-5358" />
              </button>
            </div>
            <div className="space-y-1 mb-6" data-id="element-5359">
              <NavItem active={activeSection === 'overview'} icon={<LayoutDashboard size={16} data-id="element-5361" />} label="Overview" onClick={() => setActiveSection('overview')} data-id="element-5360" />
              <NavItem active={activeSection === 'items'} icon={<ShoppingCartIcon size={16} data-id="element-5363" />} label="Quote Items" onClick={() => setActiveSection('items')} badge={quote.items.length} data-id="element-5362" />
              <NavItem active={activeSection === 'customer'} icon={<UserIcon size={16} data-id="element-5365" />} label="Customer Info" onClick={() => setActiveSection('customer')} data-id="element-5364" />
              <NavItem active={activeSection === 'terms'} icon={<ClipboardIcon size={16} data-id="element-5367" />} label="Terms & Conditions" onClick={() => setActiveSection('terms')} data-id="element-5366" />
              <NavItem active={activeSection === 'attachments'} icon={<Paperclip size={16} data-id="element-5369" />} label="Attachments" onClick={() => setActiveSection('attachments')} badge={quote.attachments.length} data-id="element-5368" />
              <NavItem active={activeSection === 'approvals'} icon={<CheckSquare size={16} data-id="element-5371" />} label="Approval Workflow" onClick={() => setActiveSection('approvals')} data-id="element-5370" />
              <NavItem active={activeSection === 'analytics'} icon={<BarChart size={16} data-id="element-5373" />} label="Analytics" onClick={() => setActiveSection('analytics')} data-id="element-5372" />
            </div>
            <div className="pt-4 border-t border-gray-200" data-id="element-5374">
              <h3 className="text-xs font-medium text-gray-500 uppercase mb-3" data-id="element-5375">
                Related
              </h3>
              <div className="space-y-1" data-id="element-5376">
                <button className="flex items-center w-full px-3 py-2 text-sm text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-md" onClick={() => setShowNotes(!showNotes)} data-id="element-5377">
                  <StickyNoteIcon size={16} className="mr-3" data-id="element-5378" />
                  Notes
                  <span className="ml-auto bg-gray-100 text-gray-600 text-xs rounded-full px-2 py-0.5 min-w-[1.25rem] text-center" data-id="element-5379">
                    {quote.notes.length}
                  </span>
                </button>
                <button className="flex items-center w-full px-3 py-2 text-sm text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-md" onClick={() => setShowHistory(!showHistory)} data-id="element-5380">
                  <HistoryIcon size={16} className="mr-3" data-id="element-5381" />
                  History
                </button>
              </div>
            </div>
          </div>
          <div className="mt-auto p-4 border-t border-gray-200" data-id="element-5382">
            <div className="flex flex-col space-y-2" data-id="element-5383">
              <button onClick={onEdit} className="flex items-center justify-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-5384">
                <PencilIcon size={16} className="mr-2" data-id="element-5385" />
                Edit Quote
              </button>
              <button className="flex items-center justify-center px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors" data-id="element-5386">
                <SendIcon size={16} className="mr-2" data-id="element-5387" />
                Send Quote
              </button>
            </div>
          </div>
        </div>}
      {/* Main content area */}
      <div className="flex-1 flex flex-col h-full overflow-hidden" data-id="element-5388">
        {/* Top header */}
        <header className="bg-white border-b border-gray-200 py-4 px-6 flex items-center justify-between" data-id="element-5389">
          {!showSidebar && <button onClick={() => setShowSidebar(true)} className="mr-4 text-gray-500 hover:text-gray-700" data-id="element-5390">
              <ChevronRightIcon size={20} data-id="element-5391" />
            </button>}
          <div className="flex-1" data-id="element-5392">
            <h1 className="text-xl font-semibold text-gray-900" data-id="element-5393">
              {quote.title}
            </h1>
            <p className="text-sm text-gray-500 mt-0.5" data-id="element-5394">{quote.description}</p>
          </div>
          <div className="flex items-center space-x-2" data-id="element-5395">
            <span className={`px-3 py-1 rounded-full text-xs font-medium flex items-center ${getStatusConfig(quote.status).color}`} data-id="element-5396">
              {getStatusConfig(quote.status).icon}
              <span className="ml-1.5" data-id="element-5397">
                {getStatusConfig(quote.status).label}
              </span>
            </span>
            <div className="flex items-center ml-4" data-id="element-5398">
              <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-5399">
                <DownloadIcon size={18} data-id="element-5400" />
              </button>
              <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-5401">
                <PrinterIcon size={18} data-id="element-5402" />
              </button>
              <div className="relative" ref={shareMenuRef} data-id="element-5403">
                <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md" onClick={() => setShowShareMenu(!showShareMenu)} data-id="element-5404">
                  <ShareIcon size={18} data-id="element-5405" />
                </button>
                {showShareMenu && <div className="absolute right-0 mt-2 w-56 bg-white rounded-md shadow-lg border border-gray-200 z-10" data-id="element-5406">
                    <div className="py-1" data-id="element-5407">
                      <button className="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-5408">
                        <LinkIcon size={14} className="mr-2 text-gray-500" data-id="element-5409" />
                        Copy link
                      </button>
                      <button className="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-5410">
                        <MailIcon size={14} className="mr-2 text-gray-500" data-id="element-5411" />
                        Email quote
                      </button>
                      <button className="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-5412">
                        <ExternalLinkIcon size={14} className="mr-2 text-gray-500" data-id="element-5413" />
                        Open public view
                      </button>
                    </div>
                  </div>}
              </div>
              <div className="relative" ref={actionMenuRef} data-id="element-5414">
                <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md" onClick={() => setShowActionMenu(!showActionMenu)} data-id="element-5415">
                  <MoreHorizontalIcon size={18} data-id="element-5416" />
                </button>
                {showActionMenu && <div className="absolute right-0 mt-2 w-56 bg-white rounded-md shadow-lg border border-gray-200 z-10" data-id="element-5417">
                    <div className="py-1" data-id="element-5418">
                      <button className="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-5419">
                        <CopyIcon size={14} className="mr-2 text-gray-500" data-id="element-5420" />
                        Duplicate
                      </button>
                      <button className="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-5421">
                        <ArchiveIcon size={14} className="mr-2 text-gray-500" data-id="element-5422" />
                        Archive
                      </button>
                      <button className="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-5423">
                        <RefreshCwIcon size={14} className="mr-2 text-gray-500" data-id="element-5424" />
                        Refresh
                      </button>
                      <div className="border-t border-gray-200 my-1" data-id="element-5425"></div>
                      <button className="flex w-full items-center px-4 py-2 text-sm text-red-600 hover:bg-red-50" data-id="element-5426">
                        <TrashIcon size={14} className="mr-2" data-id="element-5427" />
                        Delete
                      </button>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
        </header>
        {/* Main scrollable content */}
        <div className="flex-1 overflow-auto" data-id="element-5428">
          <div className="max-w-6xl mx-auto p-6" data-id="element-5429">
            {/* Overview Section - Redesigned for print */}
            {activeSection === 'overview' && <div data-id="element-5430">
                {/* Template Selector and Print buttons */}
                <div className="print:hidden mb-6 flex justify-between items-center" data-id="element-5431">
                  <div className="relative" ref={templateSelectorRef} data-id="element-5432">
                    <button onClick={toggleTemplateSelector} className="flex items-center px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors" data-id="element-5433">
                      <LayoutIcon size={16} className="mr-2 text-blue-600" data-id="element-5434" />
                      Cambiar Plantilla
                      <ChevronDownIcon size={16} className="ml-2 text-gray-500" data-id="element-5435" />
                    </button>
                    {showTemplateSelector && <div className="absolute left-0 mt-2 w-[600px] bg-white rounded-md shadow-lg border border-gray-200 z-20" data-id="element-5436">
                        <div className="p-4 border-b border-gray-200" data-id="element-5437">
                          <h3 className="text-lg font-medium text-gray-900" data-id="element-5438">
                            Seleccionar Plantilla
                          </h3>
                          <p className="text-sm text-gray-500 mt-1" data-id="element-5439">
                            Elige entre nuestras plantillas predefinidas para tu
                            cotización
                          </p>
                        </div>
                        <div className="grid grid-cols-3 gap-4 p-4" data-id="element-5440">
                          {/* Plantilla Estándar */}
                          <div className={`border rounded-lg overflow-hidden cursor-pointer transition-all ${selectedTemplate === 'standard' ? 'border-blue-500 ring-2 ring-blue-200' : 'border-gray-200 hover:border-blue-300'}`} onClick={() => handleSelectTemplate('standard')} data-id="element-5441">
                            <div className="h-40 bg-gray-100 p-2 flex items-center justify-center" data-id="element-5442">
                              <div className="w-full h-full bg-white rounded border border-gray-200 p-2 flex flex-col" data-id="element-5443">
                                <div className="h-6 bg-gray-200 rounded mb-2" data-id="element-5444"></div>
                                <div className="flex-1 flex" data-id="element-5445">
                                  <div className="w-1/2 pr-1" data-id="element-5446">
                                    <div className="h-4 bg-gray-200 rounded mb-1 w-3/4" data-id="element-5447"></div>
                                    <div className="h-4 bg-gray-200 rounded mb-1" data-id="element-5448"></div>
                                    <div className="h-4 bg-gray-200 rounded mb-1 w-2/3" data-id="element-5449"></div>
                                  </div>
                                  <div className="w-1/2 pl-1" data-id="element-5450">
                                    <div className="h-4 bg-gray-200 rounded mb-1 w-3/4" data-id="element-5451"></div>
                                    <div className="h-4 bg-gray-200 rounded mb-1" data-id="element-5452"></div>
                                    <div className="h-4 bg-gray-200 rounded mb-1 w-2/3" data-id="element-5453"></div>
                                  </div>
                                </div>
                                <div className="h-12 bg-gray-200 rounded mt-2" data-id="element-5454"></div>
                              </div>
                            </div>
                            <div className="p-3 bg-white" data-id="element-5455">
                              <h4 className="font-medium text-gray-900" data-id="element-5456">
                                Plantilla Estándar
                              </h4>
                              <p className="text-sm text-gray-500" data-id="element-5457">
                                Diseño profesional y equilibrado
                              </p>
                              {selectedTemplate === 'standard' && <span className="text-xs text-blue-600 font-medium flex items-center mt-1" data-id="element-5458">
                                  <CheckIcon size={12} className="mr-1" data-id="element-5459" />{' '}
                                  Seleccionada
                                </span>}
                            </div>
                          </div>
                          {/* Plantilla Profesional */}
                          <div className={`border rounded-lg overflow-hidden cursor-pointer transition-all ${selectedTemplate === 'professional' ? 'border-blue-500 ring-2 ring-blue-200' : 'border-gray-200 hover:border-blue-300'}`} onClick={() => handleSelectTemplate('professional')} data-id="element-5460">
                            <div className="h-40 bg-gray-100 p-2 flex items-center justify-center" data-id="element-5461">
                              <div className="w-full h-full bg-white rounded border border-gray-200 p-2 flex flex-col" data-id="element-5462">
                                <div className="h-8 bg-blue-100 rounded mb-2 flex items-center p-1" data-id="element-5463">
                                  <div className="h-4 w-4 rounded-full bg-blue-200 mr-2" data-id="element-5464"></div>
                                  <div className="h-3 bg-blue-200 rounded w-1/3" data-id="element-5465"></div>
                                </div>
                                <div className="flex-1 flex" data-id="element-5466">
                                  <div className="w-full" data-id="element-5467">
                                    <div className="h-3 bg-gray-200 rounded mb-1 w-full" data-id="element-5468"></div>
                                    <div className="h-3 bg-gray-200 rounded mb-1 w-full" data-id="element-5469"></div>
                                    <div className="h-3 bg-gray-200 rounded mb-1 w-3/4" data-id="element-5470"></div>
                                    <div className="h-6 bg-gray-100 rounded mt-2 mb-1" data-id="element-5471"></div>
                                    <div className="h-3 bg-gray-200 rounded mb-1 w-full" data-id="element-5472"></div>
                                    <div className="h-3 bg-gray-200 rounded mb-1 w-2/3" data-id="element-5473"></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="p-3 bg-white" data-id="element-5474">
                              <h4 className="font-medium text-gray-900" data-id="element-5475">
                                Plantilla Profesional
                              </h4>
                              <p className="text-sm text-gray-500" data-id="element-5476">
                                Diseño formal con detalles completos
                              </p>
                              {selectedTemplate === 'professional' && <span className="text-xs text-blue-600 font-medium flex items-center mt-1" data-id="element-5477">
                                  <CheckIcon size={12} className="mr-1" data-id="element-5478" />{' '}
                                  Seleccionada
                                </span>}
                            </div>
                          </div>
                          {/* Plantilla Minimalista */}
                          <div className={`border rounded-lg overflow-hidden cursor-pointer transition-all ${selectedTemplate === 'minimalist' ? 'border-blue-500 ring-2 ring-blue-200' : 'border-gray-200 hover:border-blue-300'}`} onClick={() => handleSelectTemplate('minimalist')} data-id="element-5479">
                            <div className="h-40 bg-gray-100 p-2 flex items-center justify-center" data-id="element-5480">
                              <div className="w-full h-full bg-white rounded border border-gray-200 p-2 flex flex-col" data-id="element-5481">
                                <div className="h-8 flex items-center justify-between mb-3" data-id="element-5482">
                                  <div className="h-4 w-1/4 bg-gray-200 rounded" data-id="element-5483"></div>
                                  <div className="h-4 w-1/4 bg-gray-800 rounded" data-id="element-5484"></div>
                                </div>
                                <div className="h-px bg-gray-200 w-full mb-3" data-id="element-5485"></div>
                                <div className="flex-1" data-id="element-5486">
                                  <div className="h-3 bg-gray-200 rounded mb-2 w-1/2" data-id="element-5487"></div>
                                  <div className="h-3 bg-gray-200 rounded mb-2 w-3/4" data-id="element-5488"></div>
                                  <div className="h-3 bg-gray-200 rounded w-1/3" data-id="element-5489"></div>
                                </div>
                                <div className="h-px bg-gray-200 w-full mt-3 mb-3" data-id="element-5490"></div>
                                <div className="h-4 bg-gray-800 rounded w-1/4 ml-auto" data-id="element-5491"></div>
                              </div>
                            </div>
                            <div className="p-3 bg-white" data-id="element-5492">
                              <h4 className="font-medium text-gray-900" data-id="element-5493">
                                Plantilla Minimalista
                              </h4>
                              <p className="text-sm text-gray-500" data-id="element-5494">
                                Diseño limpio, simple y directo
                              </p>
                              {selectedTemplate === 'minimalist' && <span className="text-xs text-blue-600 font-medium flex items-center mt-1" data-id="element-5495">
                                  <CheckIcon size={12} className="mr-1" data-id="element-5496" />{' '}
                                  Seleccionada
                                </span>}
                            </div>
                          </div>
                        </div>
                        {/* Banner premium */}
                        <div className="p-4 bg-gradient-to-r from-amber-50 to-yellow-50 border-t border-amber-200" data-id="element-5497">
                          <div className="flex items-center" data-id="element-5498">
                            <div className="mr-4 flex-shrink-0" data-id="element-5499">
                              <div className="h-12 w-12 bg-amber-100 rounded-full flex items-center justify-center" data-id="element-5500">
                                <CrownIcon size={24} className="text-amber-600" data-id="element-5501" />
                              </div>
                            </div>
                            <div data-id="element-5502">
                              <h4 className="font-medium text-gray-900" data-id="element-5503">
                                Personaliza con tu marca
                              </h4>
                              <p className="text-sm text-gray-600 mt-1" data-id="element-5504">
                                Contrata Aisco Workspace Premium y obtén
                                plantillas personalizadas con el logo y colores
                                de tu empresa.
                              </p>
                              <button className="mt-2 text-sm px-3 py-1 bg-amber-500 text-white rounded-md hover:bg-amber-600 transition-colors inline-flex items-center" data-id="element-5505">
                                <CrownIcon size={14} className="mr-1" data-id="element-5506" />
                                Conocer Premium
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>}
                  </div>
                  <button onClick={handlePrintQuote} className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-5507">
                    <PrinterIcon size={16} className="mr-2" data-id="element-5508" />
                    Imprimir Cotización
                  </button>
                </div>
                {/* Plantilla Estándar */}
                {selectedTemplate === 'standard' && <div ref={printableQuoteRef} className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-5509">
                    {/* Quote Header */}
                    <div className="p-8 border-b border-gray-200" data-id="element-5510">
                      <div className="flex justify-between items-start" data-id="element-5511">
                        <div data-id="element-5512">
                          <div className="h-16 w-40 bg-gray-100 flex items-center justify-center rounded mb-4" data-id="element-5513">
                            <FileTextIcon size={32} className="text-gray-400" data-id="element-5514" />
                          </div>
                          <h2 className="text-2xl font-bold text-gray-900" data-id="element-5515">
                            Valley Irrigation
                          </h2>
                          <p className="text-gray-600" data-id="element-5516">
                            123 Corporate Way, Omaha, NE 68137
                          </p>
                          <p className="text-gray-600" data-id="element-5517">
                            +1 (800) 825-6668 | info@valleyirrigation.com
                          </p>
                        </div>
                        <div className="text-right" data-id="element-5518">
                          <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-5519">
                            COTIZACIÓN
                          </h1>
                          <div className="text-gray-600" data-id="element-5520">
                            <p data-id="element-5521">
                              <span className="font-medium" data-id="element-5522">Cotización #:</span>{' '}
                              {quote.id}
                            </p>
                            <p data-id="element-5523">
                              <span className="font-medium" data-id="element-5524">Fecha:</span>{' '}
                              {quote.date}
                            </p>
                            <p data-id="element-5525">
                              <span className="font-medium" data-id="element-5526">Válido hasta:</span>{' '}
                              {quote.expiresIn}
                            </p>
                            <p className={`mt-2 font-medium ${expiryStatus.color}`} data-id="element-5527">
                              {expiryStatus.label}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Customer & Quote Information */}
                    <div className="p-8 border-b border-gray-200" data-id="element-5528">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-5529">
                        <div data-id="element-5530">
                          <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-5531">
                            Información del Cliente
                          </h3>
                          <div className="bg-gray-50 p-4 rounded-lg" data-id="element-5532">
                            <p className="font-medium text-gray-800" data-id="element-5533">
                              {quote.customer}
                            </p>
                            <p className="text-gray-600" data-id="element-5534">{quote.company}</p>
                            <p className="text-gray-600" data-id="element-5535">
                              {quote.companyAddress}
                            </p>
                            <div className="mt-3" data-id="element-5536">
                              <p className="text-gray-600" data-id="element-5537">
                                <span className="font-medium" data-id="element-5538">Email:</span>{' '}
                                {quote.customerEmail}
                              </p>
                              <p className="text-gray-600" data-id="element-5539">
                                <span className="font-medium" data-id="element-5540">Teléfono:</span>{' '}
                                {quote.customerPhone}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div data-id="element-5541">
                          <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-5542">
                            Detalles de la Cotización
                          </h3>
                          <div className="bg-gray-50 p-4 rounded-lg" data-id="element-5543">
                            <h4 className="font-medium text-gray-800 text-lg mb-2" data-id="element-5544">
                              {quote.title}
                            </h4>
                            <p className="text-gray-600 mb-3" data-id="element-5545">
                              {quote.description}
                            </p>
                            <div className="grid grid-cols-2 gap-4" data-id="element-5546">
                              <div data-id="element-5547">
                                <p className="text-gray-600" data-id="element-5548">
                                  <span className="font-medium" data-id="element-5549">Región:</span>{' '}
                                  {quote.region}
                                </p>
                                <p className="text-gray-600" data-id="element-5550">
                                  <span className="font-medium" data-id="element-5551">País:</span>{' '}
                                  {quote.country}
                                </p>
                              </div>
                              <div data-id="element-5552">
                                <p className="text-gray-600" data-id="element-5553">
                                  <span className="font-medium" data-id="element-5554">
                                    Cotizado por:
                                  </span>{' '}
                                  {quote.quotedBy}
                                </p>
                                <p className="text-gray-600" data-id="element-5555">
                                  <span className="font-medium" data-id="element-5556">
                                    Gerente de Ventas:
                                  </span>{' '}
                                  {quote.salesManager}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Quote Items */}
                    <div className="p-8 border-b border-gray-200" data-id="element-5557">
                      <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-5558">
                        Artículos de la Cotización
                      </h3>
                      <div className="overflow-x-auto" data-id="element-5559">
                        <table className="min-w-full divide-y divide-gray-200" data-id="element-5560">
                          <thead data-id="element-5561">
                            <tr className="bg-gray-50" data-id="element-5562">
                              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5563">
                                Descripción del Artículo
                              </th>
                              <th scope="col" className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5564">
                                Cantidad
                              </th>
                              <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5565">
                                Precio Unitario
                              </th>
                              <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5566">
                                Descuento
                              </th>
                              <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5567">
                                Total
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200" data-id="element-5568">
                            {quote.items.map(item => <tr key={item.id} data-id="element-5569">
                                <td className="px-6 py-4" data-id="element-5570">
                                  <div className="text-sm font-medium text-gray-900" data-id="element-5571">
                                    {item.name}
                                  </div>
                                  <div className="text-sm text-gray-500" data-id="element-5572">
                                    {item.description}
                                  </div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500" data-id="element-5573">
                                  {item.quantity}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm text-gray-500" data-id="element-5574">
                                  {formatCurrency(item.unitPrice)}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm text-gray-500" data-id="element-5575">
                                  {item.discount > 0 ? `${item.discount}%` : '-'}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium text-gray-900" data-id="element-5576">
                                  {formatCurrency(item.total)}
                                </td>
                              </tr>)}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {/* Quote Summary */}
                    <div className="p-8 border-b border-gray-200" data-id="element-5577">
                      <div className="flex justify-end" data-id="element-5578">
                        <div className="w-full md:w-1/2 lg:w-1/3" data-id="element-5579">
                          <div className="space-y-2" data-id="element-5580">
                            <div className="flex justify-between text-sm" data-id="element-5581">
                              <span className="text-gray-600" data-id="element-5582">Subtotal:</span>
                              <span className="text-gray-800 font-medium" data-id="element-5583">
                                {formatCurrency(quote.amount)}
                              </span>
                            </div>
                            {quote.discount > 0 && <div className="flex justify-between text-sm" data-id="element-5584">
                                <span className="text-gray-600" data-id="element-5585">
                                  Descuento ({quote.discount}%):
                                </span>
                                <span className="text-green-600 font-medium" data-id="element-5586">
                                  -
                                  {formatCurrency(quote.amount * (quote.discount / 100))}
                                </span>
                              </div>}
                            <div className="flex justify-between text-sm" data-id="element-5587">
                              <span className="text-gray-600" data-id="element-5588">
                                Impuesto ({quote.tax}%):
                              </span>
                              <span className="text-gray-800 font-medium" data-id="element-5589">
                                {formatCurrency(quote.taxAmount)}
                              </span>
                            </div>
                            <div className="border-t border-gray-200 pt-2 mt-2" data-id="element-5590">
                              <div className="flex justify-between text-base" data-id="element-5591">
                                <span className="font-medium text-gray-800" data-id="element-5592">
                                  Total:
                                </span>
                                <span className="font-bold text-blue-600" data-id="element-5593">
                                  {formatCurrency(quote.total)}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Terms & Payment */}
                    <div className="p-8 border-b border-gray-200" data-id="element-5594">
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-5595">
                        <div data-id="element-5596">
                          <h3 className="text-sm font-semibold text-gray-700 mb-2" data-id="element-5597">
                            Condiciones de Pago
                          </h3>
                          <p className="text-gray-600" data-id="element-5598">{quote.paymentTerms}</p>
                        </div>
                        <div data-id="element-5599">
                          <h3 className="text-sm font-semibold text-gray-700 mb-2" data-id="element-5600">
                            Condiciones de Entrega
                          </h3>
                          <p className="text-gray-600" data-id="element-5601">{quote.deliveryTerms}</p>
                        </div>
                        <div data-id="element-5602">
                          <h3 className="text-sm font-semibold text-gray-700 mb-2" data-id="element-5603">
                            Validez de la Cotización
                          </h3>
                          <p className="text-gray-600" data-id="element-5604">
                            {quote.validityPeriod}
                          </p>
                        </div>
                      </div>
                    </div>
                    {/* Notes & Terms */}
                    <div className="p-8" data-id="element-5605">
                      <h3 className="text-sm font-semibold text-gray-700 mb-2" data-id="element-5606">
                        Notas y Términos
                      </h3>
                      <p className="text-gray-600 mb-6" data-id="element-5607">{quote.terms}</p>
                      <div className="mt-8 pt-8 border-t border-gray-200" data-id="element-5608">
                        <div className="grid grid-cols-2 gap-8" data-id="element-5609">
                          <div data-id="element-5610">
                            <h4 className="text-sm font-semibold text-gray-700 mb-4" data-id="element-5611">
                              Aceptación del Cliente
                            </h4>
                            <div className="h-px bg-gray-300 mb-1 w-full" data-id="element-5612"></div>
                            <p className="text-gray-500 text-sm" data-id="element-5613">Firma</p>
                            <div className="h-px bg-gray-300 mb-1 mt-6 w-full" data-id="element-5614"></div>
                            <p className="text-gray-500 text-sm" data-id="element-5615">Fecha</p>
                          </div>
                          <div data-id="element-5616">
                            <h4 className="text-sm font-semibold text-gray-700 mb-4" data-id="element-5617">
                              Representante de Valley Irrigation
                            </h4>
                            <div className="h-px bg-gray-300 mb-1 w-full" data-id="element-5618"></div>
                            <p className="text-gray-500 text-sm" data-id="element-5619">Firma</p>
                            <div className="h-px bg-gray-300 mb-1 mt-6 w-full" data-id="element-5620"></div>
                            <p className="text-gray-500 text-sm" data-id="element-5621">Fecha</p>
                          </div>
                        </div>
                      </div>
                      <div className="mt-12 text-center text-gray-500 text-sm" data-id="element-5622">
                        <p data-id="element-5623">¡Gracias por su preferencia!</p>
                        <p data-id="element-5624">
                          Para cualquier consulta sobre esta cotización,
                          contáctenos en {quote.customerEmail}
                        </p>
                      </div>
                    </div>
                  </div>}
                {/* Plantilla Profesional */}
                {selectedTemplate === 'professional' && <div ref={printableQuoteRef} className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-5625">
                    {/* Encabezado con color */}
                    <div className="bg-blue-600 text-white p-8" data-id="element-5626">
                      <div className="flex justify-between items-center" data-id="element-5627">
                        <div className="flex items-center" data-id="element-5628">
                          <div className="h-16 w-16 bg-white rounded-full flex items-center justify-center mr-4" data-id="element-5629">
                            <FileTextIcon size={32} className="text-blue-600" data-id="element-5630" />
                          </div>
                          <div data-id="element-5631">
                            <h1 className="text-3xl font-bold" data-id="element-5632">COTIZACIÓN</h1>
                            <p className="text-blue-100 mt-1" data-id="element-5633">
                              Soluciones de Irrigación de Precisión
                            </p>
                          </div>
                        </div>
                        <div className="text-right" data-id="element-5634">
                          <div className="inline-block bg-blue-700 rounded-lg px-4 py-2" data-id="element-5635">
                            <p className="text-blue-100 text-sm" data-id="element-5636">
                              Cotización #
                            </p>
                            <p className="text-xl font-bold" data-id="element-5637">{quote.id}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Información de la empresa y cliente */}
                    <div className="p-8 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-5638">
                      <div data-id="element-5639">
                        <h2 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-600" data-id="element-5640">
                          DATOS DE LA EMPRESA
                        </h2>
                        <div className="space-y-2" data-id="element-5641">
                          <p className="text-lg font-semibold text-gray-800" data-id="element-5642">
                            Valley Irrigation
                          </p>
                          <p className="text-gray-600" data-id="element-5643">123 Corporate Way</p>
                          <p className="text-gray-600" data-id="element-5644">Omaha, NE 68137</p>
                          <p className="text-gray-600" data-id="element-5645">Estados Unidos</p>
                          <p className="text-gray-600" data-id="element-5646">+1 (800) 825-6668</p>
                          <p className="text-gray-600" data-id="element-5647">
                            info@valleyirrigation.com
                          </p>
                          <p className="text-gray-600" data-id="element-5648">
                            www.valleyirrigation.com
                          </p>
                        </div>
                      </div>
                      <div data-id="element-5649">
                        <h2 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-600" data-id="element-5650">
                          CLIENTE
                        </h2>
                        <div className="space-y-2" data-id="element-5651">
                          <p className="text-lg font-semibold text-gray-800" data-id="element-5652">
                            {quote.customer}
                          </p>
                          <p className="text-gray-600" data-id="element-5653">{quote.company}</p>
                          <p className="text-gray-600" data-id="element-5654">
                            {quote.companyAddress}
                          </p>
                          <p className="text-gray-600" data-id="element-5655">
                            <span className="font-medium" data-id="element-5656">Email:</span>{' '}
                            {quote.customerEmail}
                          </p>
                          <p className="text-gray-600" data-id="element-5657">
                            <span className="font-medium" data-id="element-5658">Teléfono:</span>{' '}
                            {quote.customerPhone}
                          </p>
                        </div>
                      </div>
                    </div>
                    {/* Información de la cotización */}
                    <div className="px-8 py-6 bg-gray-50 border-t border-b border-gray-200" data-id="element-5659">
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-5660">
                        <div data-id="element-5661">
                          <p className="text-sm text-gray-500" data-id="element-5662">
                            FECHA DE EMISIÓN
                          </p>
                          <p className="font-medium text-gray-800" data-id="element-5663">
                            {quote.date}
                          </p>
                        </div>
                        <div data-id="element-5664">
                          <p className="text-sm text-gray-500" data-id="element-5665">VÁLIDA HASTA</p>
                          <p className="font-medium text-gray-800" data-id="element-5666">
                            {quote.expiresIn}
                          </p>
                        </div>
                        <div data-id="element-5667">
                          <p className="text-sm text-gray-500" data-id="element-5668">COTIZADO POR</p>
                          <p className="font-medium text-gray-800" data-id="element-5669">
                            {quote.quotedBy}
                          </p>
                        </div>
                        <div data-id="element-5670">
                          <p className="text-sm text-gray-500" data-id="element-5671">
                            CONDICIONES DE PAGO
                          </p>
                          <p className="font-medium text-gray-800" data-id="element-5672">
                            {quote.paymentTerms}
                          </p>
                        </div>
                      </div>
                    </div>
                    {/* Descripción del proyecto */}
                    <div className="p-8" data-id="element-5673">
                      <h2 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-600" data-id="element-5674">
                        DESCRIPCIÓN DEL PROYECTO
                      </h2>
                      <div className="bg-blue-50 border border-blue-100 rounded-lg p-4 mb-6" data-id="element-5675">
                        <h3 className="font-semibold text-lg text-gray-900 mb-2" data-id="element-5676">
                          {quote.title}
                        </h3>
                        <p className="text-gray-700" data-id="element-5677">{quote.description}</p>
                      </div>
                      {/* Items de la cotización */}
                      <h2 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-600" data-id="element-5678">
                        DETALLE DE PRODUCTOS Y SERVICIOS
                      </h2>
                      <div className="overflow-x-auto" data-id="element-5679">
                        <table className="min-w-full border border-gray-200 rounded-lg overflow-hidden" data-id="element-5680">
                          <thead data-id="element-5681">
                            <tr className="bg-blue-600 text-white" data-id="element-5682">
                              <th scope="col" className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider" data-id="element-5683">
                                Descripción
                              </th>
                              <th scope="col" className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider" data-id="element-5684">
                                Cantidad
                              </th>
                              <th scope="col" className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider" data-id="element-5685">
                                Precio Unitario
                              </th>
                              <th scope="col" className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider" data-id="element-5686">
                                Descuento
                              </th>
                              <th scope="col" className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider" data-id="element-5687">
                                Total
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200" data-id="element-5688">
                            {quote.items.map((item, index) => <tr key={item.id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} data-id="element-5689">
                                <td className="px-6 py-4" data-id="element-5690">
                                  <div className="text-sm font-medium text-gray-900" data-id="element-5691">
                                    {item.name}
                                  </div>
                                  <div className="text-sm text-gray-500" data-id="element-5692">
                                    {item.description}
                                  </div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500" data-id="element-5693">
                                  {item.quantity}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm text-gray-500" data-id="element-5694">
                                  {formatCurrency(item.unitPrice)}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm text-gray-500" data-id="element-5695">
                                  {item.discount > 0 ? `${item.discount}%` : '-'}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium text-gray-900" data-id="element-5696">
                                  {formatCurrency(item.total)}
                                </td>
                              </tr>)}
                          </tbody>
                        </table>
                      </div>
                      {/* Resumen de la cotización */}
                      <div className="mt-8 flex justify-end" data-id="element-5697">
                        <div className="w-full md:w-1/2 lg:w-2/5 bg-gray-50 border border-gray-200 rounded-lg p-6" data-id="element-5698">
                          <h3 className="text-lg font-bold text-gray-900 mb-4 pb-2 border-b border-gray-300" data-id="element-5699">
                            RESUMEN DE LA COTIZACIÓN
                          </h3>
                          <div className="space-y-3" data-id="element-5700">
                            <div className="flex justify-between text-sm" data-id="element-5701">
                              <span className="text-gray-600" data-id="element-5702">Subtotal:</span>
                              <span className="text-gray-800 font-medium" data-id="element-5703">
                                {formatCurrency(quote.amount)}
                              </span>
                            </div>
                            {quote.discount > 0 && <div className="flex justify-between text-sm" data-id="element-5704">
                                <span className="text-gray-600" data-id="element-5705">
                                  Descuento ({quote.discount}%):
                                </span>
                                <span className="text-green-600 font-medium" data-id="element-5706">
                                  -
                                  {formatCurrency(quote.amount * (quote.discount / 100))}
                                </span>
                              </div>}
                            <div className="flex justify-between text-sm" data-id="element-5707">
                              <span className="text-gray-600" data-id="element-5708">
                                Impuesto ({quote.tax}%):
                              </span>
                              <span className="text-gray-800 font-medium" data-id="element-5709">
                                {formatCurrency(quote.taxAmount)}
                              </span>
                            </div>
                            <div className="border-t border-gray-300 pt-3 mt-3" data-id="element-5710">
                              <div className="flex justify-between" data-id="element-5711">
                                <span className="font-bold text-gray-800 text-lg" data-id="element-5712">
                                  TOTAL:
                                </span>
                                <span className="font-bold text-blue-600 text-xl" data-id="element-5713">
                                  {formatCurrency(quote.total)}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Términos y condiciones */}
                      <div className="mt-8" data-id="element-5714">
                        <h2 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b-2 border-blue-600" data-id="element-5715">
                          TÉRMINOS Y CONDICIONES
                        </h2>
                        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4" data-id="element-5716">
                          <p className="text-gray-700 whitespace-pre-line" data-id="element-5717">
                            {quote.terms}
                          </p>
                          <p className="text-gray-700 mt-4" data-id="element-5718">
                            Condiciones de entrega: {quote.deliveryTerms}
                          </p>
                          <p className="text-gray-700" data-id="element-5719">
                            Validez de la oferta: {quote.validityPeriod}
                          </p>
                        </div>
                      </div>
                      {/* Firmas */}
                      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-5720">
                        <div className="border-t-2 border-gray-300 pt-4" data-id="element-5721">
                          <p className="font-medium text-gray-800" data-id="element-5722">
                            Aceptación del Cliente
                          </p>
                          <p className="text-gray-500 text-sm" data-id="element-5723">
                            Nombre, Firma y Fecha
                          </p>
                        </div>
                        <div className="border-t-2 border-gray-300 pt-4" data-id="element-5724">
                          <p className="font-medium text-gray-800" data-id="element-5725">
                            Por Valley Irrigation
                          </p>
                          <p className="text-gray-500 text-sm" data-id="element-5726">
                            Nombre, Firma y Fecha
                          </p>
                        </div>
                      </div>
                      {/* Footer */}
                      <div className="mt-16 pt-8 border-t border-gray-200 text-center" data-id="element-5727">
                        <p className="text-gray-500" data-id="element-5728">
                          Esta cotización fue generada por Valley Irrigation -
                          Soluciones de Irrigación de Precisión
                        </p>
                        <p className="text-gray-500 mt-1" data-id="element-5729">
                          Para cualquier consulta, contacte a su representante
                          de ventas o visite www.valleyirrigation.com
                        </p>
                      </div>
                    </div>
                  </div>}
                {/* Plantilla Minimalista */}
                {selectedTemplate === 'minimalist' && <div ref={printableQuoteRef} className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-5730">
                    {/* Encabezado minimalista */}
                    <div className="p-8" data-id="element-5731">
                      <div className="flex justify-between items-center" data-id="element-5732">
                        <div data-id="element-5733">
                          <h1 className="text-2xl font-bold text-gray-900" data-id="element-5734">
                            Cotización
                          </h1>
                          <p className="text-gray-500" data-id="element-5735">{quote.id}</p>
                        </div>
                        <div className="text-right" data-id="element-5736">
                          <div className="h-12 w-36 bg-gray-100 flex items-center justify-center rounded" data-id="element-5737">
                            <FileTextIcon size={24} className="text-gray-400" data-id="element-5738" />
                          </div>
                        </div>
                      </div>
                      <div className="h-px bg-gray-200 w-full my-6" data-id="element-5739"></div>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-5740">
                        <div data-id="element-5741">
                          <p className="text-xs text-gray-500 uppercase mb-1" data-id="element-5742">
                            De
                          </p>
                          <p className="font-medium text-gray-800" data-id="element-5743">
                            Valley Irrigation
                          </p>
                          <p className="text-gray-600 text-sm" data-id="element-5744">
                            123 Corporate Way, Omaha
                          </p>
                          <p className="text-gray-600 text-sm" data-id="element-5745">
                            NE 68137, Estados Unidos
                          </p>
                          <p className="text-gray-600 text-sm mt-1" data-id="element-5746">
                            info@valleyirrigation.com
                          </p>
                        </div>
                        <div data-id="element-5747">
                          <p className="text-xs text-gray-500 uppercase mb-1" data-id="element-5748">
                            Para
                          </p>
                          <p className="font-medium text-gray-800" data-id="element-5749">
                            {quote.customer}
                          </p>
                          <p className="text-gray-600 text-sm" data-id="element-5750">
                            {quote.company}
                          </p>
                          <p className="text-gray-600 text-sm" data-id="element-5751">
                            {quote.companyAddress}
                          </p>
                          <p className="text-gray-600 text-sm mt-1" data-id="element-5752">
                            {quote.customerEmail}
                          </p>
                        </div>
                        <div data-id="element-5753">
                          <p className="text-xs text-gray-500 uppercase mb-1" data-id="element-5754">
                            Detalles
                          </p>
                          <div className="flex justify-between text-sm" data-id="element-5755">
                            <span className="text-gray-600" data-id="element-5756">Fecha:</span>
                            <span className="text-gray-800" data-id="element-5757">{quote.date}</span>
                          </div>
                          <div className="flex justify-between text-sm mt-1" data-id="element-5758">
                            <span className="text-gray-600" data-id="element-5759">Válido hasta:</span>
                            <span className="text-gray-800" data-id="element-5760">
                              {quote.expiresIn}
                            </span>
                          </div>
                          <div className="flex justify-between text-sm mt-1" data-id="element-5761">
                            <span className="text-gray-600" data-id="element-5762">Términos:</span>
                            <span className="text-gray-800" data-id="element-5763">
                              {quote.paymentTerms}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Título del proyecto */}
                    <div className="px-8 py-4 bg-gray-50 border-t border-b border-gray-200" data-id="element-5764">
                      <h2 className="text-xl font-medium text-gray-900" data-id="element-5765">
                        {quote.title}
                      </h2>
                      <p className="text-gray-600 mt-1" data-id="element-5766">{quote.description}</p>
                    </div>
                    {/* Items de la cotización - Estilo minimalista */}
                    <div className="p-8" data-id="element-5767">
                      <table className="min-w-full" data-id="element-5768">
                        <thead data-id="element-5769">
                          <tr className="border-b border-gray-200" data-id="element-5770">
                            <th scope="col" className="pb-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5771">
                              Artículo
                            </th>
                            <th scope="col" className="pb-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5772">
                              Cant.
                            </th>
                            <th scope="col" className="pb-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5773">
                              Precio
                            </th>
                            <th scope="col" className="pb-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5774">
                              Total
                            </th>
                          </tr>
                        </thead>
                        <tbody data-id="element-5775">
                          {quote.items.map(item => <tr key={item.id} className="border-b border-gray-100" data-id="element-5776">
                              <td className="py-4" data-id="element-5777">
                                <div className="text-sm font-medium text-gray-900" data-id="element-5778">
                                  {item.name}
                                </div>
                                <div className="text-xs text-gray-500 mt-1" data-id="element-5779">
                                  {item.description}
                                </div>
                              </td>
                              <td className="py-4 text-center text-sm text-gray-500" data-id="element-5780">
                                {item.quantity}
                              </td>
                              <td className="py-4 text-right text-sm text-gray-500" data-id="element-5781">
                                {formatCurrency(item.unitPrice)}
                                {item.discount > 0 && <span className="text-green-600 text-xs block" data-id="element-5782">
                                    (-{item.discount}%)
                                  </span>}
                              </td>
                              <td className="py-4 text-right text-sm font-medium text-gray-900" data-id="element-5783">
                                {formatCurrency(item.total)}
                              </td>
                            </tr>)}
                        </tbody>
                      </table>
                      {/* Resumen minimalista */}
                      <div className="mt-8 border-t border-gray-200 pt-4" data-id="element-5784">
                        <div className="flex justify-end" data-id="element-5785">
                          <div className="w-48" data-id="element-5786">
                            <div className="flex justify-between text-sm py-2" data-id="element-5787">
                              <span className="text-gray-600" data-id="element-5788">Subtotal</span>
                              <span className="text-gray-800" data-id="element-5789">
                                {formatCurrency(quote.amount)}
                              </span>
                            </div>
                            {quote.discount > 0 && <div className="flex justify-between text-sm py-2" data-id="element-5790">
                                <span className="text-gray-600" data-id="element-5791">Descuento</span>
                                <span className="text-green-600" data-id="element-5792">
                                  -
                                  {formatCurrency(quote.amount * (quote.discount / 100))}
                                </span>
                              </div>}
                            <div className="flex justify-between text-sm py-2" data-id="element-5793">
                              <span className="text-gray-600" data-id="element-5794">
                                Impuesto ({quote.tax}%)
                              </span>
                              <span className="text-gray-800" data-id="element-5795">
                                {formatCurrency(quote.taxAmount)}
                              </span>
                            </div>
                            <div className="flex justify-between font-medium text-base pt-2 border-t border-gray-200 mt-2" data-id="element-5796">
                              <span className="text-gray-800" data-id="element-5797">Total</span>
                              <span className="text-gray-900" data-id="element-5798">
                                {formatCurrency(quote.total)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Notas y términos - Estilo minimalista */}
                    <div className="px-8 py-6 bg-gray-50 border-t border-gray-200" data-id="element-5799">
                      <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-5800">
                        Notas
                      </h3>
                      <p className="text-sm text-gray-600" data-id="element-5801">{quote.terms}</p>
                    </div>
                    {/* Firma minimalista */}
                    <div className="p-8" data-id="element-5802">
                      <div className="grid grid-cols-2 gap-8" data-id="element-5803">
                        <div data-id="element-5804">
                          <div className="h-px bg-gray-300 mb-1 w-full" data-id="element-5805"></div>
                          <p className="text-gray-500 text-xs" data-id="element-5806">
                            Firma del Cliente
                          </p>
                        </div>
                        <div data-id="element-5807">
                          <div className="h-px bg-gray-300 mb-1 w-full" data-id="element-5808"></div>
                          <p className="text-gray-500 text-xs" data-id="element-5809">Fecha</p>
                        </div>
                      </div>
                      <div className="mt-12 text-center" data-id="element-5810">
                        <p className="text-xs text-gray-500" data-id="element-5811">
                          Gracias por su confianza
                        </p>
                      </div>
                    </div>
                  </div>}
              </div>}
            {/* Items Section */}
            {activeSection === 'items' && <div className="space-y-6" data-id="element-5812">
                <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-5813">
                  <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center" data-id="element-5814">
                    <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-5815">
                      <ShoppingCartIcon size={18} className="mr-2 text-gray-500" data-id="element-5816" />
                      Quote Items
                    </h2>
                    <div className="flex items-center space-x-2" data-id="element-5817">
                      <button className="text-gray-500 hover:text-gray-700 p-1" data-id="element-5818">
                        <FilterIcon size={16} data-id="element-5819" />
                      </button>
                      <button className="bg-blue-600 text-white px-3 py-1 rounded-md text-sm flex items-center hover:bg-blue-700" data-id="element-5820">
                        <PlusIcon size={14} className="mr-1" data-id="element-5821" />
                        Add Item
                      </button>
                    </div>
                  </div>
                  <div className="overflow-x-auto" data-id="element-5822">
                    <table className="min-w-full divide-y divide-gray-200" data-id="element-5823">
                      <thead className="bg-gray-50" data-id="element-5824">
                        <tr data-id="element-5825">
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5826">
                            Item
                          </th>
                          <th scope="col" className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5827">
                            Qty
                          </th>
                          <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5828">
                            Unit Price
                          </th>
                          <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5829">
                            Discount
                          </th>
                          <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5830">
                            Total
                          </th>
                          <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-5831">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200" data-id="element-5832">
                        {quote.items.map(item => <tr key={item.id} className="hover:bg-gray-50" data-id="element-5833">
                            <td className="px-6 py-4" data-id="element-5834">
                              <div className="text-sm font-medium text-gray-900" data-id="element-5835">
                                {item.name}
                              </div>
                              <div className="text-sm text-gray-500" data-id="element-5836">
                                {item.description}
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500" data-id="element-5837">
                              {item.quantity}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm text-gray-500" data-id="element-5838">
                              {formatCurrency(item.unitPrice)}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm text-gray-500" data-id="element-5839">
                              {item.discount > 0 ? <span className="text-green-600" data-id="element-5840">
                                  {item.discount}%
                                </span> : '-'}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium text-gray-900" data-id="element-5841">
                              {formatCurrency(item.total)}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-5842">
                              <div className="flex items-center justify-end space-x-2" data-id="element-5843">
                                <button className="text-blue-600 hover:text-blue-900" onClick={() => handleViewItem(item)} data-id="element-5844">
                                  <EyeIcon size={16} data-id="element-5845" />
                                </button>
                                <button className="text-gray-500 hover:text-gray-700" data-id="element-5846">
                                  <PencilIcon size={16} data-id="element-5847" />
                                </button>
                                <button className="text-red-500 hover:text-red-700" data-id="element-5848">
                                  <TrashIcon size={16} data-id="element-5849" />
                                </button>
                              </div>
                            </td>
                          </tr>)}
                      </tbody>
                      <tfoot className="bg-gray-50" data-id="element-5850">
                        <tr data-id="element-5851">
                          <td colSpan={4} className="px-6 py-3 text-right text-sm font-medium text-gray-500" data-id="element-5852">
                            Subtotal
                          </td>
                          <td className="px-6 py-3 text-right text-sm font-medium text-gray-900" data-id="element-5853">
                            {formatCurrency(quote.amount)}
                          </td>
                          <td data-id="element-5854"></td>
                        </tr>
                        {quote.discount > 0 && <tr data-id="element-5855">
                            <td colSpan={4} className="px-6 py-3 text-right text-sm font-medium text-gray-500" data-id="element-5856">
                              Discount ({quote.discount}%)
                            </td>
                            <td className="px-6 py-3 text-right text-sm font-medium text-green-600" data-id="element-5857">
                              -
                              {formatCurrency(quote.amount * (quote.discount / 100))}
                            </td>
                            <td data-id="element-5858"></td>
                          </tr>}
                        <tr data-id="element-5859">
                          <td colSpan={4} className="px-6 py-3 text-right text-sm font-medium text-gray-500" data-id="element-5860">
                            Tax ({quote.tax}%)
                          </td>
                          <td className="px-6 py-3 text-right text-sm font-medium text-gray-900" data-id="element-5861">
                            {formatCurrency(quote.taxAmount)}
                          </td>
                          <td data-id="element-5862"></td>
                        </tr>
                        <tr data-id="element-5863">
                          <td colSpan={4} className="px-6 py-3 text-right text-sm font-medium text-gray-900" data-id="element-5864">
                            Total
                          </td>
                          <td className="px-6 py-3 text-right text-sm font-medium text-blue-600" data-id="element-5865">
                            {formatCurrency(quote.total)}
                          </td>
                          <td data-id="element-5866"></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                {/* Competitive Analysis */}
                {quote.competitors && quote.competitors.length > 0 && <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-5867">
                    <div className="px-6 py-4 border-b border-gray-200" data-id="element-5868">
                      <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-5869">
                        <BarChart2Icon size={18} className="mr-2 text-gray-500" data-id="element-5870" />
                        Competitive Analysis
                      </h2>
                    </div>
                    <div className="p-6" data-id="element-5871">
                      <div className="space-y-4" data-id="element-5872">
                        <div className="flex items-center justify-between bg-blue-50 p-4 rounded-lg" data-id="element-5873">
                          <div className="flex items-center" data-id="element-5874">
                            <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-4" data-id="element-5875">
                              <CheckCircleIcon size={20} className="text-blue-600" data-id="element-5876" />
                            </div>
                            <div data-id="element-5877">
                              <div className="font-medium" data-id="element-5878">Our Quote</div>
                              <div className="text-sm text-gray-500" data-id="element-5879">
                                Valley Irrigation
                              </div>
                            </div>
                          </div>
                          <div className="text-xl font-bold text-blue-600" data-id="element-5880">
                            {formatCurrency(quote.total)}
                          </div>
                        </div>
                        {quote.competitors.map((competitor, index) => <div key={index} className="flex items-center justify-between bg-gray-50 p-4 rounded-lg" data-id="element-5881">
                            <div className="flex items-center" data-id="element-5882">
                              <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center mr-4" data-id="element-5883">
                                <BuildingIcon size={20} className="text-gray-600" data-id="element-5884" />
                              </div>
                              <div data-id="element-5885">
                                <div className="font-medium" data-id="element-5886">
                                  {competitor.name}
                                </div>
                                <div className="flex space-x-2 mt-1" data-id="element-5887">
                                  <span className="text-xs px-2 py-0.5 rounded-full bg-green-100 text-green-800" data-id="element-5888">
                                    {competitor.strengths}
                                  </span>
                                  <span className="text-xs px-2 py-0.5 rounded-full bg-red-100 text-red-800" data-id="element-5889">
                                    {competitor.weaknesses}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="text-lg font-medium text-gray-900" data-id="element-5890">
                              {formatCurrency(competitor.price)}
                            </div>
                          </div>)}
                      </div>
                      <div className="mt-6" data-id="element-5891">
                        <div className="text-sm font-medium text-gray-700 mb-2" data-id="element-5892">
                          Price Comparison
                        </div>
                        <div className="h-4 bg-gray-200 rounded-full overflow-hidden" data-id="element-5893">
                          <div className="h-full bg-blue-600" style={{
                      width: '65%'
                    }} data-id="element-5894"></div>
                        </div>
                        <div className="flex justify-between text-xs text-gray-500 mt-1" data-id="element-5895">
                          <span data-id="element-5896">Our price is competitive</span>
                          <span data-id="element-5897">35% lower than highest competitor</span>
                        </div>
                      </div>
                    </div>
                  </div>}
              </div>}
            {/* Customer Info Section */}
            {activeSection === 'customer' && <div className="space-y-6" data-id="element-5898">
                <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-5899">
                  <div className="px-6 py-4 border-b border-gray-200" data-id="element-5900">
                    <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-5901">
                      <UserIcon size={18} className="mr-2 text-gray-500" data-id="element-5902" />
                      Customer Information
                    </h2>
                  </div>
                  <div className="p-6" data-id="element-5903">
                    <div className="flex flex-col md:flex-row md:items-start" data-id="element-5904">
                      <div className="md:w-1/3 mb-6 md:mb-0 md:pr-6" data-id="element-5905">
                        <div className="flex items-center" data-id="element-5906">
                          <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-5907">
                            <UserIcon size={28} className="text-blue-600" data-id="element-5908" />
                          </div>
                          <div className="ml-4" data-id="element-5909">
                            <h3 className="text-xl font-medium text-gray-900" data-id="element-5910">
                              {quote.customer}
                            </h3>
                            <p className="text-gray-500" data-id="element-5911">{quote.company}</p>
                          </div>
                        </div>
                        <div className="mt-6 space-y-4" data-id="element-5912">
                          <div data-id="element-5913">
                            <div className="text-sm font-medium text-gray-500 mb-1" data-id="element-5914">
                              Contact Information
                            </div>
                            <div className="space-y-2" data-id="element-5915">
                              <div className="flex items-center text-gray-700" data-id="element-5916">
                                <MailIcon size={16} className="mr-2 text-gray-500" data-id="element-5917" />
                                <a href={`mailto:${quote.customerEmail}`} className="text-blue-600 hover:text-blue-800" data-id="element-5918">
                                  {quote.customerEmail}
                                </a>
                              </div>
                              <div className="flex items-center text-gray-700" data-id="element-5919">
                                <PhoneIcon size={16} className="mr-2 text-gray-500" data-id="element-5920" />
                                <a href={`tel:${quote.customerPhone}`} className="text-blue-600 hover:text-blue-800" data-id="element-5921">
                                  {quote.customerPhone}
                                </a>
                              </div>
                            </div>
                          </div>
                          <div data-id="element-5922">
                            <div className="text-sm font-medium text-gray-500 mb-1" data-id="element-5923">
                              Location
                            </div>
                            <div className="flex items-start text-gray-700" data-id="element-5924">
                              <MapPinIcon size={16} className="mr-2 mt-1 text-gray-500 flex-shrink-0" data-id="element-5925" />
                              <span data-id="element-5926">{quote.companyAddress}</span>
                            </div>
                          </div>
                          <div data-id="element-5927">
                            <div className="text-sm font-medium text-gray-500 mb-1" data-id="element-5928">
                              Region
                            </div>
                            <div className="flex items-center text-gray-700" data-id="element-5929">
                              <GlobeIcon size={16} className="mr-2 text-gray-500" data-id="element-5930" />
                              <span data-id="element-5931">
                                {quote.region}, {quote.country}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="md:w-2/3 md:border-l md:border-gray-200 md:pl-6" data-id="element-5932">
                        <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-5933">
                          Customer Activity
                        </h3>
                        <div className="space-y-6" data-id="element-5934">
                          <div data-id="element-5935">
                            <div className="text-sm font-medium text-gray-500 mb-2" data-id="element-5936">
                              Recent Quotes
                            </div>
                            <div className="bg-gray-50 rounded-lg p-4" data-id="element-5937">
                              <div className="text-center text-gray-500 py-4" data-id="element-5938">
                                <ClipboardIcon size={24} className="mx-auto mb-2 text-gray-400" data-id="element-5939" />
                                <p data-id="element-5940">
                                  No previous quotes found for this customer
                                </p>
                              </div>
                            </div>
                          </div>
                          <div data-id="element-5941">
                            <div className="text-sm font-medium text-gray-500 mb-2" data-id="element-5942">
                              Engagement
                            </div>
                            <div className="bg-gray-50 rounded-lg p-4" data-id="element-5943">
                              <div className="grid grid-cols-2 gap-4" data-id="element-5944">
                                <div data-id="element-5945">
                                  <div className="text-xs text-gray-500" data-id="element-5946">
                                    Last Contact
                                  </div>
                                  <div className="text-sm font-medium" data-id="element-5947">
                                    2 days ago
                                  </div>
                                </div>
                                <div data-id="element-5948">
                                  <div className="text-xs text-gray-500" data-id="element-5949">
                                    Response Time
                                  </div>
                                  <div className="text-sm font-medium" data-id="element-5950">
                                    4 hours avg.
                                  </div>
                                </div>
                                <div data-id="element-5951">
                                  <div className="text-xs text-gray-500" data-id="element-5952">
                                    Interactions
                                  </div>
                                  <div className="text-sm font-medium" data-id="element-5953">
                                    5 total
                                  </div>
                                </div>
                                <div data-id="element-5954">
                                  <div className="text-xs text-gray-500" data-id="element-5955">
                                    Status
                                  </div>
                                  <div className="text-sm font-medium text-blue-600" data-id="element-5956">
                                    Active
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div data-id="element-5957">
                            <div className="flex justify-between items-center mb-2" data-id="element-5958">
                              <div className="text-sm font-medium text-gray-500" data-id="element-5959">
                                Notes
                              </div>
                              <button className="text-blue-600 text-sm hover:text-blue-800" onClick={() => setShowNotes(true)} data-id="element-5960">
                                Add Note
                              </button>
                            </div>
                            <div className="bg-gray-50 rounded-lg p-4 space-y-3" data-id="element-5961">
                              {quote.notes.length > 0 ? quote.notes.map(note => <div key={note.id} className={`p-3 rounded-md ${note.isPrivate ? 'bg-blue-50 border border-blue-100' : 'bg-white border border-gray-200'}`} data-id="element-5962">
                                    <div className="flex justify-between items-start mb-1" data-id="element-5963">
                                      <div className="font-medium text-gray-900" data-id="element-5964">
                                        {note.author}
                                      </div>
                                      <div className="text-xs text-gray-500" data-id="element-5965">
                                        {note.date}
                                      </div>
                                    </div>
                                    <p className="text-sm text-gray-700" data-id="element-5966">
                                      {note.text}
                                    </p>
                                    {note.isPrivate && <div className="mt-2 text-xs flex items-center text-blue-600" data-id="element-5967">
                                        <LockIcon size={12} className="mr-1" data-id="element-5968" />
                                        Private note
                                      </div>}
                                  </div>) : <div className="text-center text-gray-500 py-4" data-id="element-5969">
                                  <MessageSquareIcon size={24} className="mx-auto mb-2 text-gray-400" data-id="element-5970" />
                                  <p data-id="element-5971">No notes available for this customer</p>
                                </div>}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
            {/* Terms & Conditions Section */}
            {activeSection === 'terms' && <div className="space-y-6" data-id="element-5972">
                <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-5973">
                  <div className="px-6 py-4 border-b border-gray-200" data-id="element-5974">
                    <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-5975">
                      <ClipboardIcon size={18} className="mr-2 text-gray-500" data-id="element-5976" />
                      Terms & Conditions
                    </h2>
                  </div>
                  <div className="p-6" data-id="element-5977">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6" data-id="element-5978">
                      <div className="bg-gray-50 p-4 rounded-lg" data-id="element-5979">
                        <div className="flex items-center mb-3" data-id="element-5980">
                          <DollarSignIcon size={18} className="text-blue-600 mr-2" data-id="element-5981" />
                          <h3 className="text-lg font-medium text-gray-900" data-id="element-5982">
                            Payment Terms
                          </h3>
                        </div>
                        <p className="text-gray-700" data-id="element-5983">{quote.paymentTerms}</p>
                        <div className="mt-4 text-sm text-gray-500" data-id="element-5984">
                          <p data-id="element-5985">
                            Payment is due according to the terms specified.
                            Late payments may be subject to additional fees.
                          </p>
                        </div>
                      </div>
                      <div className="bg-gray-50 p-4 rounded-lg" data-id="element-5986">
                        <div className="flex items-center mb-3" data-id="element-5987">
                          <TruckIcon size={18} className="text-blue-600 mr-2" data-id="element-5988" />
                          <h3 className="text-lg font-medium text-gray-900" data-id="element-5989">
                            Delivery Terms
                          </h3>
                        </div>
                        <p className="text-gray-700" data-id="element-5990">{quote.deliveryTerms}</p>
                        <div className="mt-4 text-sm text-gray-500" data-id="element-5991">
                          <p data-id="element-5992">
                            Shipping and handling costs are calculated based on
                            delivery location and product specifications.
                          </p>
                        </div>
                      </div>
                      <div className="bg-gray-50 p-4 rounded-lg" data-id="element-5993">
                        <div className="flex items-center mb-3" data-id="element-5994">
                          <ClockIcon size={18} className="text-blue-600 mr-2" data-id="element-5995" />
                          <h3 className="text-lg font-medium text-gray-900" data-id="element-5996">
                            Validity Period
                          </h3>
                        </div>
                        <p className="text-gray-700" data-id="element-5997">{quote.validityPeriod}</p>
                        <div className="mt-4 text-sm text-gray-500" data-id="element-5998">
                          <p data-id="element-5999">
                            This quote is valid for the specified period from
                            the date of issue. After this period, prices may be
                            subject to change.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="border-t border-gray-200 pt-6" data-id="element-6000">
                      <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-6001">
                        Full Terms & Conditions
                      </h3>
                      <div className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-6002">
                        <p className="text-gray-700 whitespace-pre-line" data-id="element-6003">
                          {quote.terms}
                          {/* Additional terms text for demonstration */}
                          {`\n\n1. ACCEPTANCE: This quotation constitutes an offer by Valley Irrigation ("Seller") to the customer identified on the face of this document ("Buyer") for the sale of the products described herein. Acceptance of this offer is expressly limited to the terms and conditions contained herein.
2. PRICES: Prices quoted are valid for the period indicated. Prices do not include any federal, state, or local taxes unless specifically stated. Any such taxes will be added to the invoice and paid by Buyer unless Buyer provides Seller with a valid tax exemption certificate.
3. PAYMENT: Payment terms are as specified in this quotation. Buyer agrees to pay all costs of collection, including reasonable attorney's fees, incurred by Seller in collecting any amounts due from Buyer.
4. DELIVERY: Delivery dates are approximate and based upon prompt receipt of all necessary information from Buyer. Seller shall not be liable for delays in delivery or performance due to causes beyond its reasonable control.
5. WARRANTY: Seller warrants that the products sold hereunder will be free from defects in material and workmanship for the period specified in Seller's standard warranty for such products. THIS WARRANTY IS EXCLUSIVE AND IN LIEU OF ALL OTHER WARRANTIES, EXPRESS OR IMPLIED, INCLUDING THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE.
6. LIMITATION OF LIABILITY: Seller's liability shall be limited to the cost of repairing or replacing, at Seller's option, any defective product. IN NO EVENT SHALL SELLER BE LIABLE FOR ANY SPECIAL, INDIRECT, INCIDENTAL OR CONSEQUENTIAL DAMAGES.
7. ENTIRE AGREEMENT: This quotation, together with any documents referenced herein, constitutes the entire agreement between Buyer and Seller with respect to the subject matter hereof and supersedes all prior negotiations and understandings.`}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
            {/* Attachments Section */}
            {activeSection === 'attachments' && <div className="space-y-6" data-id="element-6004">
                <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-6005">
                  <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center" data-id="element-6006">
                    <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-6007">
                      <Paperclip size={18} className="mr-2 text-gray-500" data-id="element-6008" />
                      Attachments
                    </h2>
                    <button className="bg-blue-600 text-white px-3 py-1 rounded-md text-sm flex items-center hover:bg-blue-700" data-id="element-6009">
                      <PlusIcon size={14} className="mr-1" data-id="element-6010" />
                      Add File
                    </button>
                  </div>
                  <div className="p-6" data-id="element-6011">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-6012">
                      {quote.attachments.map((attachment, index) => <div key={index} className="flex items-center p-4 border border-gray-200 rounded-lg hover:border-blue-300 hover:bg-blue-50 transition-colors" data-id="element-6013">
                          <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center mr-4" data-id="element-6014">
                            {getFileIcon(attachment.type)}
                          </div>
                          <div className="flex-1 min-w-0" data-id="element-6015">
                            <div className="text-sm font-medium text-gray-900 truncate" data-id="element-6016">
                              {attachment.name}
                            </div>
                            <div className="text-xs text-gray-500" data-id="element-6017">
                              {attachment.size}
                            </div>
                          </div>
                          <div className="flex space-x-2" data-id="element-6018">
                            <button className="text-gray-500 hover:text-gray-700 p-1" data-id="element-6019">
                              <EyeIcon size={16} data-id="element-6020" />
                            </button>
                            <button className="text-gray-500 hover:text-gray-700 p-1" data-id="element-6021">
                              <DownloadIcon size={16} data-id="element-6022" />
                            </button>
                            <button className="text-red-500 hover:text-red-700 p-1" data-id="element-6023">
                              <TrashIcon size={16} data-id="element-6024" />
                            </button>
                          </div>
                        </div>)}
                    </div>
                    <div className="mt-6 border-t border-gray-200 pt-6" data-id="element-6025">
                      <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-6026">
                        Upload New Files
                      </h3>
                      <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center" data-id="element-6027">
                        <div className="mx-auto w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mb-3" data-id="element-6028">
                          <Paperclip size={24} className="text-gray-500" data-id="element-6029" />
                        </div>
                        <p className="text-gray-700 mb-2" data-id="element-6030">
                          Drag and drop files here, or click to browse
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-6031">
                          Supported formats: PDF, DOC, XLS, JPG, PNG (Max 10MB)
                        </p>
                        <button className="mt-4 bg-blue-600 text-white px-4 py-2 rounded-md text-sm hover:bg-blue-700" data-id="element-6032">
                          Browse Files
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
            {/* Approval Workflow Section */}
            {activeSection === 'approvals' && <div className="space-y-6" data-id="element-6033">
                <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-6034">
                  <div className="px-6 py-4 border-b border-gray-200" data-id="element-6035">
                    <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-6036">
                      <CheckSquare size={18} className="mr-2 text-gray-500" data-id="element-6037" />
                      Approval Workflow
                    </h2>
                  </div>
                  <div className="p-6" data-id="element-6038">
                    <div className="max-w-3xl mx-auto" data-id="element-6039">
                      <div className="relative" data-id="element-6040">
                        <div className="absolute left-8 top-0 h-full w-0.5 bg-gray-200" data-id="element-6041"></div>
                        {/* Level 1 */}
                        <div className="relative z-10 flex items-start mb-8" data-id="element-6042">
                          <div className="flex-shrink-0 w-16 h-16 flex items-center justify-center" data-id="element-6043">
                            <div className="w-8 h-8 rounded-full bg-green-100 border-4 border-white flex items-center justify-center" data-id="element-6044">
                              <CheckIcon size={16} className="text-green-600" data-id="element-6045" />
                            </div>
                          </div>
                          <div className="flex-grow ml-4 bg-white p-5 rounded-lg border border-gray-200 shadow-sm" data-id="element-6046">
                            <div className="flex justify-between items-start" data-id="element-6047">
                              <div data-id="element-6048">
                                <h3 className="text-lg font-medium text-gray-900" data-id="element-6049">
                                  {quote.approvalStatus.level1.name}
                                </h3>
                                <p className="text-gray-500" data-id="element-6050">
                                  First level approval required for all quotes
                                </p>
                              </div>
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-6051">
                                Approved
                              </span>
                            </div>
                            <div className="mt-4 text-sm text-gray-700" data-id="element-6052">
                              <p data-id="element-6053">
                                Approved by {quote.approvalStatus.level1.by} •{' '}
                                {quote.approvalStatus.level1.date}
                              </p>
                              <p className="mt-1 text-gray-500" data-id="element-6054">
                                Comments: Pricing and terms look good. Approved
                                for next level review.
                              </p>
                            </div>
                          </div>
                        </div>
                        {/* Level 2 */}
                        {quote.approvalStatus.level2.status !== 'not_required' && <div className="relative z-10 flex items-start mb-8" data-id="element-6055">
                            <div className="flex-shrink-0 w-16 h-16 flex items-center justify-center" data-id="element-6056">
                              <div className={`w-8 h-8 rounded-full ${quote.approvalStatus.level2.status === 'approved' ? 'bg-green-100' : 'bg-amber-100'} border-4 border-white flex items-center justify-center`} data-id="element-6057">
                                {quote.approvalStatus.level2.status === 'approved' ? <CheckIcon size={16} className="text-green-600" data-id="element-6058" /> : <ClockIcon size={16} className="text-amber-600" data-id="element-6059" />}
                              </div>
                            </div>
                            <div className="flex-grow ml-4 bg-white p-5 rounded-lg border border-gray-200 shadow-sm" data-id="element-6060">
                              <div className="flex justify-between items-start" data-id="element-6061">
                                <div data-id="element-6062">
                                  <h3 className="text-lg font-medium text-gray-900" data-id="element-6063">
                                    {quote.approvalStatus.level2.name}
                                  </h3>
                                  <p className="text-gray-500" data-id="element-6064">
                                    Required for quotes over $25,000
                                  </p>
                                </div>
                                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${quote.approvalStatus.level2.status === 'approved' ? 'bg-green-100 text-green-800' : 'bg-amber-100 text-amber-800'}`} data-id="element-6065">
                                  {quote.approvalStatus.level2.status === 'approved' ? 'Approved' : 'Pending'}
                                </span>
                              </div>
                              <div className="mt-4 text-sm text-gray-700" data-id="element-6066">
                                {quote.approvalStatus.level2.status === 'approved' ? <>
                                    <p data-id="element-6067">
                                      Approved by{' '}
                                      {quote.approvalStatus.level2.by} •{' '}
                                      {quote.approvalStatus.level2.date}
                                    </p>
                                    <p className="mt-1 text-gray-500" data-id="element-6068">
                                      Comments: Financial terms verified and
                                      approved.
                                    </p>
                                  </> : <>
                                    <p data-id="element-6069">Awaiting approval</p>
                                    <p className="mt-1 text-gray-500" data-id="element-6070">
                                      This quote is currently under review by
                                      the finance department.
                                    </p>
                                    <button className="mt-3 bg-amber-100 text-amber-800 px-3 py-1 rounded-md text-sm flex items-center" data-id="element-6071">
                                      <RefreshCwIcon size={14} className="mr-1" data-id="element-6072" />
                                      Check Status
                                    </button>
                                  </>}
                              </div>
                            </div>
                          </div>}
                        {/* Level 3 */}
                        {quote.approvalStatus.level3.status !== 'not_required' && <div className="relative z-10 flex items-start" data-id="element-6073">
                            <div className="flex-shrink-0 w-16 h-16 flex items-center justify-center" data-id="element-6074">
                              <div className={`w-8 h-8 rounded-full ${quote.approvalStatus.level3.status === 'approved' ? 'bg-green-100' : quote.approvalStatus.level3.status === 'pending' ? 'bg-amber-100' : 'bg-blue-100'} border-4 border-white flex items-center justify-center`} data-id="element-6075">
                                {quote.approvalStatus.level3.status === 'approved' ? <CheckIcon size={16} className="text-green-600" data-id="element-6076" /> : quote.approvalStatus.level3.status === 'pending' ? <ClockIcon size={16} className="text-amber-600" data-id="element-6077" /> : <InfoIcon size={16} className="text-blue-600" data-id="element-6078" />}
                              </div>
                            </div>
                            <div className="flex-grow ml-4 bg-white p-5 rounded-lg border border-gray-200 shadow-sm" data-id="element-6079">
                              <div className="flex justify-between items-start" data-id="element-6080">
                                <div data-id="element-6081">
                                  <h3 className="text-lg font-medium text-gray-900" data-id="element-6082">
                                    {quote.approvalStatus.level3.name}
                                  </h3>
                                  <p className="text-gray-500" data-id="element-6083">
                                    Required for quotes over $100,000
                                  </p>
                                </div>
                                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${quote.approvalStatus.level3.status === 'approved' ? 'bg-green-100 text-green-800' : quote.approvalStatus.level3.status === 'pending' ? 'bg-amber-100 text-amber-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-6084">
                                  {quote.approvalStatus.level3.status === 'approved' ? 'Approved' : quote.approvalStatus.level3.status === 'pending' ? 'Pending' : 'Not Required'}
                                </span>
                              </div>
                              <div className="mt-4 text-sm text-gray-700" data-id="element-6085">
                                {quote.approvalStatus.level3.status === 'approved' ? <>
                                    <p data-id="element-6086">
                                      Approved by{' '}
                                      {quote.approvalStatus.level3.by} •{' '}
                                      {quote.approvalStatus.level3.date}
                                    </p>
                                    <p className="mt-1 text-gray-500" data-id="element-6087">
                                      Comments: Executive approval granted.
                                    </p>
                                  </> : quote.approvalStatus.level3.status === 'pending' ? <>
                                    <p data-id="element-6088">Awaiting approval</p>
                                    <p className="mt-1 text-gray-500" data-id="element-6089">
                                      This quote is awaiting executive review.
                                    </p>
                                  </> : <>
                                    <p data-id="element-6090">
                                      This level of approval is not required for
                                      this quote
                                    </p>
                                    <p className="mt-1 text-gray-500" data-id="element-6091">
                                      Executive approval is only needed for
                                      quotes exceeding $100,000.
                                    </p>
                                  </>}
                              </div>
                            </div>
                          </div>}
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
            {/* Analytics Section */}
            {activeSection === 'analytics' && <div className="space-y-6" data-id="element-6092">
                {/* Score Card */}
                <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-6093">
                  <div className="px-6 py-4 border-b border-gray-200" data-id="element-6094">
                    <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-6095">
                      <StarIcon size={18} className="mr-2 text-gray-500" data-id="element-6096" />
                      Quote Score
                    </h2>
                  </div>
                  <div className="p-6" data-id="element-6097">
                    <div className="flex flex-col md:flex-row items-center" data-id="element-6098">
                      <div className="relative w-40 h-40 mb-6 md:mb-0 md:mr-8" data-id="element-6099">
                        {/* Circle background */}
                        <svg className="w-full h-full" viewBox="0 0 100 100" data-id="element-6100">
                          <circle cx="50" cy="50" r="45" fill="transparent" stroke="#e5e7eb" strokeWidth="10" data-id="element-6101" />
                          <circle cx="50" cy="50" r="45" fill="transparent" stroke={quote.score >= 80 ? '#10b981' : quote.score >= 60 ? '#3b82f6' : quote.score >= 40 ? '#f59e0b' : '#ef4444'} strokeWidth="10" strokeDasharray="282.7" strokeDashoffset={282.7 - 282.7 * quote.score / 100} transform="rotate(-90 50 50)" data-id="element-6102" />
                        </svg>
                        <div className="absolute inset-0 flex items-center justify-center flex-col" data-id="element-6103">
                          <span className={`text-4xl font-bold ${getScoreColor(quote.score)}`} data-id="element-6104">
                            {quote.score}
                          </span>
                          <span className="text-sm text-gray-500" data-id="element-6105">
                            out of 100
                          </span>
                        </div>
                      </div>
                      <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-6106">
                        <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-6107">
                          <div className="flex items-center justify-between mb-2" data-id="element-6108">
                            <div className="text-sm font-medium text-gray-700" data-id="element-6109">
                              Probability of Closing
                            </div>
                            <div className="text-green-600 font-medium" data-id="element-6110">
                              Very High
                            </div>
                          </div>
                          <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-6111">
                            <div className="bg-green-600 h-2.5 rounded-full" style={{
                          width: '85%'
                        }} data-id="element-6112"></div>
                          </div>
                        </div>
                        <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-6113">
                          <div className="flex items-center justify-between mb-2" data-id="element-6114">
                            <div className="text-sm font-medium text-gray-700" data-id="element-6115">
                              Margin
                            </div>
                            <div className="text-blue-600 font-medium" data-id="element-6116">
                              Good
                            </div>
                          </div>
                          <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-6117">
                            <div className="bg-blue-600 h-2.5 rounded-full" style={{
                          width: '70%'
                        }} data-id="element-6118"></div>
                          </div>
                        </div>
                        <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-6119">
                          <div className="flex items-center justify-between mb-2" data-id="element-6120">
                            <div className="text-sm font-medium text-gray-700" data-id="element-6121">
                              Customer Relationship
                            </div>
                            <div className="text-amber-600 font-medium" data-id="element-6122">
                              Medium
                            </div>
                          </div>
                          <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-6123">
                            <div className="bg-amber-500 h-2.5 rounded-full" style={{
                          width: '50%'
                        }} data-id="element-6124"></div>
                          </div>
                        </div>
                        <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-6125">
                          <div className="flex items-center justify-between mb-2" data-id="element-6126">
                            <div className="text-sm font-medium text-gray-700" data-id="element-6127">
                              Competitive Position
                            </div>
                            <div className="text-green-600 font-medium" data-id="element-6128">
                              Strong
                            </div>
                          </div>
                          <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-6129">
                            <div className="bg-green-600 h-2.5 rounded-full" style={{
                          width: '80%'
                        }} data-id="element-6130"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Comparison with Similar Quotes */}
                <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-6131">
                  <div className="px-6 py-4 border-b border-gray-200" data-id="element-6132">
                    <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-6133">
                      <BarChart2Icon size={18} className="mr-2 text-gray-500" data-id="element-6134" />
                      Comparison with Similar Quotes
                    </h2>
                  </div>
                  <div className="p-6" data-id="element-6135">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-6136">
                      <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-6137">
                        <div className="text-sm font-medium text-gray-700 mb-2" data-id="element-6138">
                          Average Close Rate
                        </div>
                        <div className="flex items-end" data-id="element-6139">
                          <div className="text-2xl font-bold text-gray-900" data-id="element-6140">
                            68%
                          </div>
                          <div className="ml-2 text-green-600 text-sm flex items-center" data-id="element-6141">
                            <TrendingUpIcon size={14} className="mr-1" data-id="element-6142" />
                            +24%
                          </div>
                        </div>
                        <div className="text-xs text-gray-500 mt-1" data-id="element-6143">
                          This quote has a higher close rate than average
                        </div>
                      </div>
                      <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-6144">
                        <div className="text-sm font-medium text-gray-700 mb-2" data-id="element-6145">
                          Average Time to Close
                        </div>
                        <div className="flex items-end" data-id="element-6146">
                          <div className="text-2xl font-bold text-gray-900" data-id="element-6147">
                            18 days
                          </div>
                          <div className="ml-2 text-green-600 text-sm flex items-center" data-id="element-6148">
                            <TrendingDownIcon size={14} className="mr-1" data-id="element-6149" />
                            -5 days
                          </div>
                        </div>
                        <div className="text-xs text-gray-500 mt-1" data-id="element-6150">
                          This quote is closing faster than average
                        </div>
                      </div>
                      <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-6151">
                        <div className="text-sm font-medium text-gray-700 mb-2" data-id="element-6152">
                          Average Value
                        </div>
                        <div className="flex items-end" data-id="element-6153">
                          <div className="text-2xl font-bold text-gray-900" data-id="element-6154">
                            {formatCurrency(22500)}
                          </div>
                          <div className="ml-2 text-green-600 text-sm flex items-center" data-id="element-6155">
                            <TrendingUpIcon size={14} className="mr-1" data-id="element-6156" />
                            +32%
                          </div>
                        </div>
                        <div className="text-xs text-gray-500 mt-1" data-id="element-6157">
                          This quote is higher value than average
                        </div>
                      </div>
                    </div>
                    <div className="mt-6 bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-6158">
                      <div className="flex justify-between items-center mb-4" data-id="element-6159">
                        <div className="text-sm font-medium text-gray-700" data-id="element-6160">
                          Quote Value Distribution
                        </div>
                        <div className="text-sm text-gray-500" data-id="element-6161">
                          Last 6 months
                        </div>
                      </div>
                      <div className="h-40 flex items-end justify-between" data-id="element-6162">
                        <div className="flex flex-col items-center" data-id="element-6163">
                          <div className="w-8 bg-gray-300 rounded-t" style={{
                        height: '30%'
                      }} data-id="element-6164"></div>
                          <div className="text-xs text-gray-500 mt-2" data-id="element-6165">
                            $10k-$20k
                          </div>
                        </div>
                        <div className="flex flex-col items-center" data-id="element-6166">
                          <div className="w-8 bg-gray-300 rounded-t" style={{
                        height: '50%'
                      }} data-id="element-6167"></div>
                          <div className="text-xs text-gray-500 mt-2" data-id="element-6168">
                            $20k-$30k
                          </div>
                        </div>
                        <div className="flex flex-col items-center" data-id="element-6169">
                          <div className="w-8 bg-blue-600 rounded-t" style={{
                        height: '65%'
                      }} data-id="element-6170"></div>
                          <div className="text-xs text-blue-600 font-medium mt-2" data-id="element-6171">
                            $30k-$40k
                          </div>
                        </div>
                        <div className="flex flex-col items-center" data-id="element-6172">
                          <div className="w-8 bg-gray-300 rounded-t" style={{
                        height: '40%'
                      }} data-id="element-6173"></div>
                          <div className="text-xs text-gray-500 mt-2" data-id="element-6174">
                            $40k-$50k
                          </div>
                        </div>
                        <div className="flex flex-col items-center" data-id="element-6175">
                          <div className="w-8 bg-gray-300 rounded-t" style={{
                        height: '25%'
                      }} data-id="element-6176"></div>
                          <div className="text-xs text-gray-500 mt-2" data-id="element-6177">
                            $50k-$60k
                          </div>
                        </div>
                        <div className="flex flex-col items-center" data-id="element-6178">
                          <div className="w-8 bg-gray-300 rounded-t" style={{
                        height: '15%'
                      }} data-id="element-6179"></div>
                          <div className="text-xs text-gray-500 mt-2" data-id="element-6180">
                            $60k+
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Recommended Actions */}
                <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-6181">
                  <div className="px-6 py-4 border-b border-gray-200" data-id="element-6182">
                    <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-6183">
                      <ZapIcon size={18} className="mr-2 text-gray-500" data-id="element-6184" />
                      Recommended Actions
                    </h2>
                  </div>
                  <div className="p-6" data-id="element-6185">
                    <div className="space-y-4" data-id="element-6186">
                      <div className="flex items-start bg-blue-50 rounded-lg p-4 border border-blue-200" data-id="element-6187">
                        <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center mr-3 mt-0.5" data-id="element-6188">
                          <PhoneIcon size={16} className="text-blue-600" data-id="element-6189" />
                        </div>
                        <div data-id="element-6190">
                          <h3 className="text-gray-900 font-medium" data-id="element-6191">
                            Schedule Follow-up Call
                          </h3>
                          <p className="text-gray-600 text-sm mt-1" data-id="element-6192">
                            It's been 5 days since the last contact. Schedule a
                            follow-up call to discuss any questions.
                          </p>
                          <button className="mt-2 text-blue-600 hover:text-blue-800 text-sm flex items-center" data-id="element-6193">
                            <PlusIcon size={14} className="mr-1" data-id="element-6194" />
                            Schedule Call
                          </button>
                        </div>
                      </div>
                      <div className="flex items-start bg-green-50 rounded-lg p-4 border border-green-200" data-id="element-6195">
                        <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center mr-3 mt-0.5" data-id="element-6196">
                          <PercentIcon size={16} className="text-green-600" data-id="element-6197" />
                        </div>
                        <div data-id="element-6198">
                          <h3 className="text-gray-900 font-medium" data-id="element-6199">
                            Offer Time-Limited Discount
                          </h3>
                          <p className="text-gray-600 text-sm mt-1" data-id="element-6200">
                            Based on historical data, offering a 5% time-limited
                            discount could increase the close probability by
                            15%.
                          </p>
                          <button className="mt-2 text-blue-600 hover:text-blue-800 text-sm flex items-center" data-id="element-6201">
                            <PenToolIcon size={14} className="mr-1" data-id="element-6202" />
                            Create Offer
                          </button>
                        </div>
                      </div>
                      <div className="flex items-start bg-amber-50 rounded-lg p-4 border border-amber-200" data-id="element-6203">
                        <div className="w-8 h-8 rounded-full bg-amber-100 flex items-center justify-center mr-3 mt-0.5" data-id="element-6204">
                          <FileTextIcon size={16} className="text-amber-600" data-id="element-6205" />
                        </div>
                        <div data-id="element-6206">
                          <h3 className="text-gray-900 font-medium" data-id="element-6207">
                            Send Additional Product Information
                          </h3>
                          <p className="text-gray-600 text-sm mt-1" data-id="element-6208">
                            Customer has shown interest in maintenance plans.
                            Send additional information about service packages.
                          </p>
                          <button className="mt-2 text-blue-600 hover:text-blue-800 text-sm flex items-center" data-id="element-6209">
                            <MailIcon size={14} className="mr-1" data-id="element-6210" />
                            Send Information
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
          </div>
        </div>
      </div>
      {/* Right sidebar - Notes or History */}
      {(showNotes || showHistory) && <div className="w-80 bg-white border-l border-gray-200 flex flex-col h-full" data-id="element-6211">
          {showNotes && <>
              <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-6212">
                <h3 className="text-lg font-semibold text-gray-900 flex items-center" data-id="element-6213">
                  <StickyNoteIcon size={18} className="mr-2 text-gray-500" data-id="element-6214" />
                  Notes
                </h3>
                <button className="text-gray-500 hover:text-gray-700" onClick={() => setShowNotes(false)} data-id="element-6215">
                  <XIcon size={18} data-id="element-6216" />
                </button>
              </div>
              <div className="p-4 flex-1 overflow-auto" data-id="element-6217">
                <div className="flex justify-between items-center mb-4" data-id="element-6218">
                  <h4 className="font-medium text-gray-900" data-id="element-6219">Quote Notes</h4>
                  <div className="text-xs text-gray-500" data-id="element-6220">
                    {quote.notes.length} notes
                  </div>
                </div>
                <div className="space-y-4 mb-6" data-id="element-6221">
                  {quote.notes.map(note => <div key={note.id} className={`p-3 rounded-md ${note.isPrivate ? 'bg-blue-50 border border-blue-100' : 'bg-gray-50 border border-gray-200'}`} data-id="element-6222">
                      <div className="flex justify-between items-start mb-1" data-id="element-6223">
                        <div className="font-medium text-gray-900" data-id="element-6224">
                          {note.author}
                        </div>
                        <div className="text-xs text-gray-500" data-id="element-6225">{note.date}</div>
                      </div>
                      <p className="text-sm text-gray-700" data-id="element-6226">{note.text}</p>
                      {note.isPrivate && <div className="mt-2 text-xs flex items-center text-blue-600" data-id="element-6227">
                          <LockIcon size={12} className="mr-1" data-id="element-6228" />
                          Private note
                        </div>}
                    </div>)}
                </div>
                <div className="border-t border-gray-200 pt-4" data-id="element-6229">
                  <h4 className="font-medium text-gray-900 mb-2" data-id="element-6230">Add a Note</h4>
                  <textarea className="w-full border border-gray-300 rounded-md p-3 text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none" placeholder="Type your note here..." rows={4} value={newNote} onChange={e => setNewNote(e.target.value)} data-id="element-6231"></textarea>
                  <div className="flex justify-between mt-2" data-id="element-6232">
                    <label className="flex items-center text-sm text-gray-700" data-id="element-6233">
                      <input type="checkbox" className="mr-2 border-gray-300 rounded text-blue-600 focus:ring-blue-500" checked={privateNote} onChange={e => setPrivateNote(e.target.checked)} data-id="element-6234" />
                      Private note
                    </label>
                    <button className="bg-blue-600 hover:bg-blue-700 text-white text-sm rounded-md px-3 py-1.5 transition-colors" onClick={handleAddNote} data-id="element-6235">
                      Save Note
                    </button>
                  </div>
                </div>
              </div>
            </>}
          {showHistory && <>
              <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-6236">
                <h3 className="text-lg font-semibold text-gray-900 flex items-center" data-id="element-6237">
                  <HistoryIcon size={18} className="mr-2 text-gray-500" data-id="element-6238" />
                  History
                </h3>
                <button className="text-gray-500 hover:text-gray-700" onClick={() => setShowHistory(false)} data-id="element-6239">
                  <XIcon size={18} data-id="element-6240" />
                </button>
              </div>
              <div className="p-4 flex-1 overflow-auto" data-id="element-6241">
                <div className="relative" data-id="element-6242">
                  <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-gray-200" data-id="element-6243"></div>
                  <div className="space-y-6 pl-12 relative" data-id="element-6244">
                    {quote.history.map((event, index) => <div key={index} className="relative" data-id="element-6245">
                        <div className="absolute -left-12 w-8 h-8 rounded-full bg-blue-100 border-4 border-white flex items-center justify-center" data-id="element-6246">
                          {event.action.includes('created') && <FileTextIcon size={16} className="text-blue-600" data-id="element-6247" />}
                          {event.action.includes('sent') && <SendIcon size={16} className="text-blue-600" data-id="element-6248" />}
                          {event.action.includes('viewed') && <EyeIcon size={16} className="text-blue-600" data-id="element-6249" />}
                          {event.action.includes('updated') && <RefreshCwIcon size={16} className="text-blue-600" data-id="element-6250" />}
                        </div>
                        <div data-id="element-6251">
                          <div className="flex justify-between items-start" data-id="element-6252">
                            <h4 className="font-medium text-gray-900" data-id="element-6253">
                              {event.action}
                            </h4>
                            <div className="text-xs text-gray-500" data-id="element-6254">
                              {event.date}
                            </div>
                          </div>
                          <p className="text-gray-600 text-sm mt-1" data-id="element-6255">
                            {event.user} • {event.details}
                          </p>
                        </div>
                      </div>)}
                  </div>
                </div>
              </div>
            </>}
        </div>}
      {/* Item Details Drawer */}
      {showItemDrawer && selectedItem && <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-end" data-id="element-6256">
          <div className="bg-white w-full max-w-md h-full overflow-auto" data-id="element-6257">
            <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-6258">
              <h3 className="text-lg font-semibold text-gray-900" data-id="element-6259">
                Item Details
              </h3>
              <button className="text-gray-500 hover:text-gray-700" onClick={() => setShowItemDrawer(false)} data-id="element-6260">
                <XIcon size={18} data-id="element-6261" />
              </button>
            </div>
            <div className="p-6" data-id="element-6262">
              <div className="mb-6" data-id="element-6263">
                <h2 className="text-xl font-bold text-gray-900 mb-1" data-id="element-6264">
                  {selectedItem.name}
                </h2>
                <p className="text-gray-600" data-id="element-6265">{selectedItem.description}</p>
              </div>
              <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-6266">
                <div className="bg-gray-50 p-4 rounded-md" data-id="element-6267">
                  <div className="text-sm text-gray-500 mb-1" data-id="element-6268">Quantity</div>
                  <div className="text-xl font-bold text-gray-900" data-id="element-6269">
                    {selectedItem.quantity}
                  </div>
                </div>
                <div className="bg-gray-50 p-4 rounded-md" data-id="element-6270">
                  <div className="text-sm text-gray-500 mb-1" data-id="element-6271">Unit Price</div>
                  <div className="text-xl font-bold text-gray-900" data-id="element-6272">
                    {formatCurrency(selectedItem.unitPrice)}
                  </div>
                </div>
                <div className="bg-gray-50 p-4 rounded-md" data-id="element-6273">
                  <div className="text-sm text-gray-500 mb-1" data-id="element-6274">Discount</div>
                  <div className="text-xl font-bold text-gray-900" data-id="element-6275">
                    {selectedItem.discount > 0 ? `${selectedItem.discount}%` : 'None'}
                  </div>
                </div>
                <div className="bg-gray-50 p-4 rounded-md" data-id="element-6276">
                  <div className="text-sm text-gray-500 mb-1" data-id="element-6277">Total</div>
                  <div className="text-xl font-bold text-blue-600" data-id="element-6278">
                    {formatCurrency(selectedItem.total)}
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 p-4 rounded-md mb-6" data-id="element-6279">
                <div className="text-sm text-gray-500 mb-2" data-id="element-6280">Profit Margin</div>
                <div className="flex items-center justify-between mb-2" data-id="element-6281">
                  <span className="text-gray-900" data-id="element-6282">32% margin</span>
                  <span className="text-green-600 text-sm" data-id="element-6283">Good</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-6284">
                  <div className="bg-green-600 h-2 rounded-full" style={{
                width: '65%'
              }} data-id="element-6285"></div>
                </div>
              </div>
              <div className="border-t border-gray-200 pt-6" data-id="element-6286">
                <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-6287">
                  Specifications
                </h3>
                <div className="space-y-4" data-id="element-6288">
                  <div className="bg-gray-50 p-4 rounded-md" data-id="element-6289">
                    <div className="text-sm text-gray-500 mb-1" data-id="element-6290">
                      Product Code
                    </div>
                    <div className="text-gray-900" data-id="element-6291">{`PROD-${selectedItem.id}${selectedItem.id * 100}`}</div>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-md" data-id="element-6292">
                    <div className="text-sm text-gray-500 mb-1" data-id="element-6293">Category</div>
                    <div className="text-gray-900" data-id="element-6294">Irrigation Equipment</div>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-md" data-id="element-6295">
                    <div className="text-sm text-gray-500 mb-1" data-id="element-6296">Warranty</div>
                    <div className="text-gray-900" data-id="element-6297">2 years standard</div>
                  </div>
                </div>
              </div>
              <div className="flex justify-end mt-6 space-x-3" data-id="element-6298">
                <button className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50" onClick={() => setShowItemDrawer(false)} data-id="element-6299">
                  Close
                </button>
                <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700" data-id="element-6300">
                  Edit Item
                </button>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}
// Navigation Item Component
function NavItem({
  active,
  icon,
  label,
  onClick,
  badge
}) {
  return <button className={`flex items-center w-full px-3 py-2 rounded-md ${active ? 'bg-blue-50 text-blue-600' : 'text-gray-700 hover:bg-gray-100'}`} onClick={onClick} data-id="element-6301">
      <span className={`${active ? 'text-blue-600' : 'text-gray-500'} mr-3`} data-id="element-6302">
        {icon}
      </span>
      <span className="text-sm font-medium" data-id="element-6303">{label}</span>
      {badge !== undefined && <span className={`ml-auto ${active ? 'bg-blue-100 text-blue-600' : 'bg-gray-100 text-gray-600'} text-xs rounded-full px-2 py-0.5 min-w-[1.25rem] text-center`} data-id="element-6304">
          {badge}
        </span>}
    </button>;
}